<template>
  <div>
    <!-- pagination loader start -->
    <div
      class="modal"
      v-bind:class="{ active: showPaginationloader === true }"
      id="coupon-modal"
      v-if="showPaginationloader"
    >
          	<loading-icon
										class="loading-icon newLoader paginationloader"
										name="ball-clip-rotate-multiple"
										color="#ba2126"
										scale="1"
						></loading-icon>
     
    </div>
<!-- pagination loader end -->
    <div
      class="modal"
      v-bind:class="{ active: opencheckstorepopupmodal === true }"
      id="coupon-modal"
      v-if="opencheckstorepopupmodal"
    >
      <div class="modal-dialog listStorePopup">
        <div class="modal-content">
          <div class="modal-body">
            <!-- class="close" -->
            <button
              type="button"
              class="close"
              @click="opencheckstorepopupmodal = false"
              style="
                margin-top: 0px;
                margin-right: 15px;
                z-index: 999;
                top: 15px;
                right: 0px;
                font-size: 25px;
              "
            >
              &times;
            </button>
            <div>
              <div class="storePopupHeading">
                <h3>{{ storename }}</h3>
                <small>{{ otherstores.length }} Stores near you</small>
              </div>
              <div class="storeWrap">
                <div class="row storePopupDetail">
                  <div class="col-7">
                    <strong>Address</strong>
                  </div>
                  <div class="col-2">
                    <strong>Rating</strong>
                  </div>
                  <div class="col-3">
                    <strong>Distance</strong>
                  </div>
                </div>

                <div
                  class="row storePopupData"
                  v-for="(store, i) in otherstores"
                  :key="i"
                >
                  <router-link
                    class="col-7 popuplink"
                    :to="{ path: '/store.html', query: { store: store.id } }"
                  >
                    <div style="display: flex; justify-content: space-between">
                      {{
                        store.name
                          .replace(/"/g, "")
                          .substring(store.name.indexOf(",") + 1)
                      }}
                      <img
                        v-if="store.temp_store_close==1"
                        
                        height="25"
                        src="/img/store-closed-icon.png"
                        alt="Store Closed"
                      />
                    </div>
                  </router-link>
                  <div class="col-2">
                    <i class="fa fa-star"></i>
                    {{ store.ratings.avg_rating }}
                  </div>
                  <div class="col-3">{{ Math.floor(store.distance) }} km</div>
                </div>
              </div>
            </div>
          </div>

          <!-- <Login /> -->
        </div>
      </div>
    </div>
    <!-- <div class="checkstorepopup" v-if="opencheckstorepopupmodal">
			
				
		</div> -->
		 
		<div class="container-fluid product-list-main">
			<div
				class="success_message"
				v-text="this.$root.success_message"
				v-if="this.$root.success_message != ''"
			></div>

			<div class="row">
				
				<!-- <div
					class="col-12"
					v-if="
            this.filter_status == false &&
            category_mobile_image != '' &&
            category_mobile_image != null
          "
          style="margin-bottom: 15px"
        >
          <img :src="category_mobile_image" class="w-100" />
        </div> -->
        <!-- <div
          class="col-12 storeHeader"
          v-if="
            this.filter_status == true &&
            category_image != '' &&
            category_image != null
          "
					:style="{ backgroundImage: `url(${category_image})` }"
				>
					<h2 class="listPageHeading">{{ this.$root.title }}</h2> -->
					<!-- <img :src="category_image" class="w-100 catBanner" /> -->
				<!-- </div> -->
			</div>
			<div class="row" v-if="listBreadcrumb != 0">
				<div class="col-xs-12 back-store-btn mt-4">
					<nav aria-label="breadcrumb" class="detail-page-breadcrumb breadcrumb-hide plpBread">
						<ol class="breadcrumb">
							<li class="breadcrumb-item">
								<router-link  :to="{path:'/'}">Home</router-link >
							</li>
							<li class="breadcrumb-item" v-for="(item, index) in this.listBreadcrumb" :key="index" >
								<router-link  :to="'/category/' + item.url_key+ '.html'">
									{{item.name}}	 
								</router-link >
									<!-- <nuxt-link :to="{path:'/category/'+item.url_key+'.html'}" v-text="item.name">
									
									</nuxt-link> -->
									<!-- {{item.url_key}}  -->
							</li>  
						</ol>  
					</nav>
				</div>
			</div>
			<div class="row" v-if="!this.$route.query.isFromStore " style="border-bottom: 1px solid #ededed">
				
				<div class="col-12 text-center">
					<div class="tabWrap">
						<p>
							<span @click="toggleProducts" :class="{ listTabActive: !this.$root.isStore }" class>Products</span>
							<span @click="toggleStores" :class="{ listTabActive: this.$root.isStore }" class>Stores</span>
						</p>
					</div>
				</div>
			</div>
			<div class="row" v-if="noProduct">
				<div class="col-12 text-center">
					<img
						src="/img/wndw_coming_soon.png"
						style="width: 24%; padding: 100px 0px"
						class="img-fluid"
						alt
					/>
				</div>
			</div>
			<!-- Stores Section -->
			<div id="nearby" v-if="this.$root.isStore">
				<!-- <div class="cardGrid row p-0 px-4">
          <div class="sort">
            <div class="right">
              <h2 class="font-bold storeCount forDesktop" v-if="stores">
                {{ stores.length }} Stores
              <h2>
              <ul class="filters">
               
                <li
                  class="filter"
                  @click="addStoreFilter(name.id_category)"
                  v-for="(name, i) in storeFilterCategories"
                  :key="i"
                  v-if="i < 3"
                >
                  {{ name.name.replace("and", "&") }}
                </li>
                <li class="filter" @click="storeFliterId = null">All Stores</li>
              </ul>
              <p class="storeFilter forDesktop" @click="isFilter = true">
                Filters <img src="/img/storeFilter.png" alt="" />
              </p>
            </div>
          </div>
				</div>-->
          


				<div v-if="stores.length" class="cardGrid row">
					<div v-if="stores.length == 0 && store_loader == false " class="col-12 text-center">
						<img
							src="/img/wndw_coming_soon.png"
							style="width: 24%; padding: 100px 0px"
							class="img-fluid"
							alt
						/>
					</div>
					<div
						class="col-md-3 col-sm-4 col-6 my-2"
						:to="{ path: '/store.html', query: { store: item.id } }"
						v-for="(item, i) in stores"
						:key="i"
						@click="storePopUpHandler(item.all_stores)"
					>
						<Card :item="item" />
					</div>
				</div>
			</div>

			<!-- Stores Section  ends here-->
			<!-- products section -->
			<div v-else >
				<div class="row pt-3" v-if="blankpage === false && pageload === false">
					<div id="sidebar-main" class="col-md-2 sidebar-main" v-if="this.filter_status === true">
						<nav id="sidebar-inner">
							<div class="sidebar-header">
								<h3 class="font-bold">Filters</h3>
							</div>
              <div class="filterSkeleton" v-if="filters.length == 0">
              <PuSkeleton class="SkeletonFilter1"  height='inherit'  />
              </div>
							<div class="applied-filter" v-if="filtersAppied.length != 0">
								<h3>Applied Filters</h3>
								<ul>
									<li v-for="(items, index) in filterview" :key="index">
										<a href="#" class="remove" @click.prevent="removefilter(index)">
											<span>Remove This Item</span>
										</a>
										<span class="filter-label"></span>
										<span v-text="items"></span>
									</li>
								</ul>
								<a href="#" class="filter-clear" @click.prevent="removeallfilter()">
									<span>Clear All</span>
								</a>
							</div>
							<ul v-if="!isMobile" class="list-unstyled components">
								<li
									class="filter-box"
									v-for="(filters, index1) of this.filters"
									:key="index1"
									:class="{ color: filters.filter_lable === 'Color' }"
								>
									<a
										href="#"
										@click.prevent="toggle"
										:class="{
                      'dropdown-toggle mobile-active': filterActive(
                        filters.filter_lable
                      ),
                    }"
                    class="dropdown-toggle active"
                    v-text="filters.filter_lable"
                  ></a>
                  <ul
                    class="collapse list-unstyled"
                    :class="{
                      'mobile-active': filterActive(filters.filter_lable),
                    }"
                  >
                    <li
                      v-for="(option, index, i) in filters.options"
                      :key="index"
                      :class="option.value_key"
                    >
                      <a
                        href="#"
                        v-text="option.value"
                        :class="{
                          check: isActive(option.code + '-' + option.value),
                        }"
                        @click.prevent="
                          addfilter(
                            filters.filter_lable,
                            option.code,
                            option.value,
                            option.value
                          )
                        "
                        :value="filters.filter_lable + '_' + option.value"
                      ></a>
                    </li>
                    <!-- commented for only data changes -->
                    <!-- <div
                      v-if="
                        filters.options.length > 5 ||
                        Object.keys(filters.options).length > 5
                      "
                    >
                      <p
                        class="filterMore"
                        v-if="activeValue == null || index1 != activeValue"
                        @click="toggleFilters(index1)"
                      >
                        View More (+{{
                          filters.options.length - 5 ||
                          Object.keys(filters.options).length - 5
                        }})
                      </p>
                      <p class="filterMore" v-else @click="toggleFilters(null)">
                        View Less
                      </p>
										</div>-->
                    <!-- commented for only data changes ENDS HERE -->
                  </ul>
                </li>
              </ul>
              <ul v-else class="list-unstyled components">
                <li
                  class="filter-box"
                  v-for="(filters, index1) of this.filters"
                  :key="index1"
                  :class="{ color: filters.filter_lable === 'Color' }"
                >
                  <a
                    href="#"
                    @click.prevent="toggle"
                    :class="{
                      'dropdown-toggle mobile-active': filterActive(
                        filters.filter_lable
                      ),
                    }"
                    class="dropdown-toggle active"
                    v-text="filters.filter_lable"
                  ></a>
                  <ul
                    class="collapse list-unstyled"
                    :class="{
                      'mobile-active': filterActive(filters.filter_lable),
                    }"
                  >
                    <li
                      v-for="(option, index, i) in filters.options"
                      :key="index"
                      :class="option.value_key"
                    >
                      <a
                        href="#"
                        v-text="option.value"
                        :class="{
                          check: isActive(option.code + '-' + option.value),
                        }"
                        @click.prevent="
                          addfilter(
                            filters.filter_lable,
                            option.code,
                            option.value,
                            option.value
                          )
                        "
                        :value="filters.filter_lable + '_' + option.value"
                        v-if="option.value != ''"
                      ></a>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
            <button @click="close_mobile_filter" class="apply_mobile_filter">
              Apply
            </button>
            <button @click="close_mobile_filter" class="close_mobile_filter">
              Close
            </button>
          </div>
          <div class="col-md-10 col-12 product-section-main">
            <div class="row">
              <div class="col-md-12" >
                <div class="" v-if="!categorie_name"> 
                    <PuSkeleton class=" SkeletonitemPLPHeader" height="inherit" style="padding:0 ; " />
                </div>
                <div class="col-md-12" v-else>
                  <div class="row" >
                    <div class="col-md-9 item-count ">
                      <h2 v-text="categorie_name"></h2>
                    </div>
                    <!-- <select class="form-control product-sort" v-model="select_sort"
                                            :value="select_sort">
                                            <option v-for="(item,index) of this.$store.state.list.sort" v-text="item.label"
                                                v-if="item.label != 'Price'" :value="item.code"></option>
                                        </select>
                                       
                                        <div class="sortoverlay" v-show="sort_show==true"
                                            @click="select_sort_click(select_sort)">
                                            <ul class="sort-dropdown">
                                                <li class="heading font-bold">SORT BY</li>
                                                <li v-for="(item,index) of sort"
                                                    :class="{'active': select_sort == item.code}"
                                                    @click="select_sort_click(item.code)" v-if="item.label != 'Price'"
                                                    v-text="item.label"></li>
                                            </ul>
										</div>-->
                    <div class="col-md-3 sort-item-count">
                      <div
                        class="sortDrop product-sort w-100"
                        @change="sortonChange($event)"
                      >
                        <span>
                          Sort By
                          <span class="sortTitle"
                            >: {{ select_sort_value }}</span
                          >
                          <i class="fa fa-angle-down float-right"></i>
                        </span>
                        <ul class="sortDropList">
                          <li
                            v-for="(item, index) of sort"
                            :key="index"
                            v-text="item.label"
                            v-if="item.label != 'Price'"
                            :value="item.code"
                            :class="
                              select_sort_value == item.label
                                ? 'sortActive'
                                : ''
                            "
                            @click="sortonChangeDesktop(item)"
                          ></li>
                        </ul>
                      </div>
                      <!-- <select
												class="form-control product-sort forMobile"
												v-model="select_sort"
												:value="select_sort"
												@change="sortonChange($event)" >
												<option
													v-for="(item, index) of sort"
													v-text="item.label"
													v-if="item.label != 'Price'"
													:value="item.code"
												></option>
											</select>-->
											<button
												class="mobile-filter"
												v-if="this.filter_status === false"
												@click="filter_show"
											>Filter</button>
										</div>
									</div>
								</div>
							</div> 
							
              <div v-if="otherstorecheck==true && otherstores.length> 0 && categorie_name"  class="col-xs-8 store-head float-right">  
								Haven't found what you're looking for? Browse other <strong>{{storename}}</strong> stores <span @click="openotherstoremodal" class="checkotherstores">here</span></div>

							<div v-if="otherstorecheck==true" class="col-md-12 back-store-btn" style="margin-top:12px; margin-bottom: 10px, font-size:15px">
								<router-link :to="{ path: '/store.html', query: { store: this.$route.query.store } }" class="text-dark col-xs-4 mBacktoStore">
									<img style="margin-top:-3px" src="/img/back-icon.png"/>	<span class="BackToStore">Back To Store</span>
								</router-link>
							
							</div>
							
							<div class="col-md-12 product-list" style="margin-bottom:30px">
								<div v-if="Product_list.length == 0 && product_loader == false " class="col-12 text-center">
									<img
										src="/img/wndw_coming_soon.png"
										style="width: 24%; padding: 100px 0px"
										class="img-fluid"
										alt
									/>
								</div>

								<!-- is Grocery -->

								<div class="row m-0" v-if="isGrocery">
									<!-- <div class="col-md-12 my-2">
                    <div
                      class="error_message"
                      v-text="this.filter_error_msg"
                      v-if="this.filter_error_msg != ''"
                    ></div>
									</div>-->

									<div
										class="col-md-3 col-sm-6 col-xs-6 col-6 pr-0"
										v-for="(article, index) of Product_list"
										:key="index"
									>
										<div class="mt-4">
											<div class="gProductSlider">
												<div class="gProductImg">
													<router-link
														:to="{
                                name: 'detail',
                                params: {
                                  pro_id: article.id_product,
                                  pro_url_key: article.url_key,
                                },
                                query: {
                                  store: article.store,
                                  id: article.id_product,
                                },
                              }"
														:key="article.id_category"
														@click.native="
                                gtm_product_click(
                                  article.name,
                                  article.sku,
                                  article.selling_price,
                                  article.category,
                                  index
                                )
                              "
													>
														<!-- <div class="product_image"
                                :style="{ backgroundImage: `url(${article.image})`}">
														</div>-->

														<responsive-image
															v-bind:desktop="`${$root.image_url_c}inside/280x280/${article.image}`"
															v-bind:tab="`${$root.image_url_c}inside/280x280/${article.image}`"
															v-bind:mobile="`${$root.image_url_c}inside/280x280/${article.image}`"
															v-bind:default_image="`${$root.image_url_c}inside/280x280/${article.image}`"
															custom_class="new_product_image"
														/>

														<div
															class="gDiscount"
															v-if="article.selling_price != article.price"
														>{{ $root.percentOff(article.price,article.selling_price)}}</div>
													</router-link>
													<div @click="getSeeOtherBuyingOptions(article)" class="listOtherOptions">
														<span>Buying Options</span>
														<i class="fa fa-ellipsis-v" aria-hidden="true"></i>
													</div>
												</div>
												<router-link
													:to="{
                              name: 'detail',
                              params: {
                                pro_id: article.id_product,
                                pro_url_key: article.url_key,
                              },
                              query: {
                                store: article.store,
                                id: article.id_product,
                              },
                            }"
													:key="article.id_category"
													@click.native="
                              gtm_product_click(
                                article.name,
                                article.sku,
                                article.selling_price,
                                article.category,
                                index
                              )
                            "
												>
													<div class="gProductDetail">
														<p class="gProductName">{{ article.name }}</p>

														<p class="gProductPrice" v-if="article.selling_price != article.price">
															{{ article.selling_price | formatMoney }}
															<del>{{ article.price | formatMoney}}</del>
															<span
																v-show="article.net_weight"
																style="color: #b20101; font-weight: bold"
																class="gProductUnit pl-3"
															>{{ article.net_weight }}</span>
														</p>
														<p class="gProductPrice" v-else>
															{{ article.selling_price | formatMoney}}
															<span
																v-show="article.net_weight"
																style="color: #b20101; font-weight: bold"
																class="gProductUnit pl-3"
															>{{ article.net_weight }}</span>
														</p>
													</div>
												</router-link>

												<!-- <div v-if="article.net_weight" v-show="article.net_weight" class="gWeight forDesktop">{{ article.net_weight }}</div> -->

												<div
													:class="article.net_weight == null ? 'noWeight': '' "
													v-if="!showQuantity(article.id_product)"
													class="gProductAdd"
												>
													<button @click="add_to_cart(article)">
														ADD
														<span>&#43;</span>
													</button>
												</div>
												<div v-else class="gProductAdd">
													<div class="product-add">
														<a
															href="#"
															@click.prevent="qty_minus(itemInCart(article.id_product), index)"
															v-bind:class="{ disabled: itemInCart(article.id_product).qty === 1 }"
														>
															<i class="fa fa-minus"></i>
														</a>
														<input
															class="add-product-input"
															type="text"
															:value="itemInCart(article.id_product).qty"
															readonly
														/>
														<a
															@click.prevent="qty_plus(itemInCart(article.id_product))"
															href="#"
															v-bind:class="{
                                max_disabled: itemInCart(article.id_product).qty >= itemInCart(article.id_product).max_qty,
                                max_disabled: itemInCart(article.id_product).qty >= 5,
                              }"
														>
															<i class="fa fa-plus"></i>
														</a>
													</div>
												</div>
												<img
													class="expressDelivery"
													v-if="article.express_store.is_express_delivery_available == true"
													src="/img/expressDelivery.png"
													alt
												/>
											</div>
										</div>
									</div>
								</div>
                  
                  <!-- is pharmacy -->
								<div class="row m-0" v-else-if="isPharmacy">
									<!-- <div class="col-md-12 my-2">
                    <div
                      class="error_message"
                      v-text="this.filter_error_msg"
                      v-if="this.filter_error_msg != ''"
                    ></div>
									</div>-->

									<div
										class="col-md-3 col-sm-6 col-xs-6 col-6 pr-0"
										v-for="(article, index) of Product_list"
										:key="index"
									>
										<div class="mt-4">
											<div class="gProductSlider">
												<div class="gProductImg">
													<router-link
														:to="{
                                name: 'detail',
                                params: {
                                  pro_id: article.id_product,
                                  pro_url_key: article.url_key,
                                },
                                query: {
                                  store: article.store,
                                  id: article.id_product,
                                },
                              }"
														:key="article.id_category"
														@click.native="
                                gtm_product_click(
                                  article.name,
                                  article.sku,
                                  article.selling_price,
                                  article.category,
                                  index
                                )
                              "
													>
														<!-- <div class="product_image"
                                :style="{ backgroundImage: `url(${article.image})`}">
														</div>-->

														<responsive-image
															v-bind:desktop="`${$root.image_url_c}inside/280x280/${article.image}`"
															v-bind:tab="`${$root.image_url_c}inside/280x280/${article.image}`"
															v-bind:mobile="`${$root.image_url_c}inside/280x280/${article.image}`"
															v-bind:default_image="`${$root.image_url_c}inside/280x280/${article.image}`"
															custom_class="new_product_image"
														/>

														<div
															class="gDiscount"
															v-if="article.selling_price != article.price"
														>{{ $root.percentOff(article.price,article.selling_price)}}</div>
													</router-link>
													<div @click="getSeeOtherBuyingOptions(article)" class="listOtherOptions">
														<span>Buying Options</span>
														<i class="fa fa-ellipsis-v" aria-hidden="true"></i>
													</div>
												</div>
												<router-link
													:to="{
                              name: 'detail',
                              params: {
                                pro_id: article.id_product,
                                pro_url_key: article.url_key,
                              },
                              query: {
                                store: article.store,
                                id: article.id_product,
                              },
                            }"
													:key="article.id_category"
													@click.native="
                              gtm_product_click(
                                article.name,
                                article.sku,
                                article.selling_price,
                                article.category,
                                index
                              )
                            "
												>
													<div class="gProductDetail">
														<p class="gProductName">{{ article.name }}</p>

														<p class="gProductPrice" v-if="article.selling_price != article.price">
															{{ article.selling_price | formatMoney }}
															<del>{{ article.price | formatMoney}}</del>
															<span
																v-show="article.net_weight"
																style="color: #b20101; font-weight: bold"
																class="gProductUnit pl-3"
															>{{ article.net_weight }}</span>
														</p>
														<p class="gProductPrice" v-else>
															{{ article.selling_price | formatMoney}}
															<span
																v-show="article.net_weight"
																style="color: #b20101; font-weight: bold"
																class="gProductUnit pl-3"
															>{{ article.net_weight }}</span>
														</p>
													</div>
												</router-link>

												<!-- <div v-if="article.net_weight" v-show="article.net_weight" class="gWeight forDesktop">{{ article.net_weight }}</div> -->

												<div
													:class="article.net_weight == null ? 'noWeight': '' "
													v-if="!showQuantity(article.id_product)"
													class="gProductAdd"
												>
													<button @click="add_to_cart(article)">
														ADD
														<span>&#43;</span>
													</button>
												</div>
												<div v-else class="gProductAdd">
													<div class="product-add">
														<a
															href="#"
															@click.prevent="qty_minus(itemInCart(article.id_product), index)"
															v-bind:class="{ disabled: itemInCart(article.id_product).qty === 1 }"
														>
															<i class="fa fa-minus"></i>
														</a>
														<input
															class="add-product-input"
															type="text"
															:value="itemInCart(article.id_product).qty"
															readonly
														/>
														<a
															@click.prevent="qty_plus(itemInCart(article.id_product))"
															href="#"
															v-bind:class="{
                                max_disabled: itemInCart(article.id_product).qty >= itemInCart(article.id_product).max_qty,
                                max_disabled: itemInCart(article.id_product).qty >= 5,
                              }"
														>
															<i class="fa fa-plus"></i>
														</a>
													</div>
												</div>
												<img
													class="expressDelivery"
													v-if="article.express_store.is_express_delivery_available == true"
													src="/img/expressDelivery.png"
													alt
												/>
											</div>
										</div>
									</div>
								</div>

								<!-- is pharmacy ends here -->

						

								<div class="row m-0" v-else>
									
									<!-- <div class="col-md-12">
										<div
										class="error_message"
										v-text="this.filter_error_msg"
										v-if="this.filter_error_msg != ''"
										></div>
									</div>-->
									
									
									<div
										class="col-md-3 col-sm-6 col-xs-6 col-6 pr-0"
										v-for="(article, index) of Product_list"
										:key="index"
									>
										<div class="slide-box">
											<div class="product-box">
												<!--div class="offer-tag">New</div-->
												<!-- <router-link
                                                :to="{name:'detail', params:{ pro_id: article.id_product, pro_url_key:article.url_key,},
                                                query: { store: article.store }
                                                }"
                                                :key="article.id_category" class="view-detail"
                                                @click.native="gtm_product_click(article.name,article.sku,article.selling_price,article.category,index)">
                                                View Detail
												</router-link>-->
                        <router-link
                         
                          :to="{
                            name: 'detail',
                            params: {
                              pro_id: article.id_product,
                              pro_url_key: article.url_key,
                            },
                            query: {
                              store: article.store,
                              id: article.id_product,
                            },
                          }"
                          :key="article.id_category"
                          @click.native="
                            gtm_product_click(
                              article.name,
                              article.sku,
                              article.selling_price,
                              article.category,
                              index
                            )
                          "
                        >
                          <!-- <div
                            class="product_image"
                            :style="{
                              backgroundImage: `url(${article.image})`,
                            }"
													></div>-->
                          <responsive-image
                            v-bind:desktop="`${$root.image_url_c}inside/280x280/${article.image}`"
                            v-bind:tab="`${$root.image_url_c}inside/280x280/${article.image}`"
                            v-bind:mobile="`${$root.image_url_c}inside/280x280/${article.image}`"
                            v-bind:default_image="`${$root.image_url_c}inside/280x280/${article.image}`"
                            custom_class="new_product_image"
                          />
                        </router-link>
                        <a
                          href="javaScript:void(0);"
                          class="listWish"
                          @click="wishlistHandler(article.id_product)"
                        >
                          <i
                            :class="
                              productsInWishlist.includes(
                                parseInt(article.id_product)
                              )
                                ? 'fa fa-heart text-logo-color'
                                : 'fa fa-heart-o'
                            "
                          ></i>
                        </a>
                        <div
                          @click="getSeeOtherBuyingOptions(article)"
                          class="listOtherOptions"
                        >
                          <span>Buying Options</span>
                          <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                        </div>
                        <div class="viewDetails">
                          <router-link
                            
                            :to="{
                              name: 'detail',
                              params: {
                                pro_id: article.id_product,
                                pro_url_key: article.url_key,
                              },
                              query: {
                                store: article.store,
                                id: article.id_product,
                              },
                            }"
                            :key="article.id_category"
                            @click.native="
                              gtm_product_click(
                                article.name,
                                article.sku,
                                article.selling_price,
                                article.category,
                                index
                              )
                            "
                            >View Details</router-link
                          >
                        </div>
                      </div>
                      <p>
                        <router-link
                          :to="{
                            name: 'detail',
                            params: {
                              pro_id: article.id_product,
                              pro_url_key: article.url_key,
                            },
                            query: {
                              store: article.store,
                              id: article.id_product,
                            },
                          }"
                          :key="article.id_category"
                          @click.native="
                            gtm_product_click(
                              article.name,
                              article.sku,
                              article.selling_price,
                              article.category,
                              index
                            )
                          "
                          v-text="article.name"
                        ></router-link>
                      </p>
                      <!-- v-if="article.selling_price != article.price" -->
                      <div
                        class="price"
                        v-if="article.selling_price != article.price"
                      >
                        <p>
                          <span class="price">{{
                            article.selling_price | formatMoney
                          }}</span>
                          <span class="old-price">{{
                            article.price | formatMoney
                          }}</span>
                          <span
                            class="discount_percent font-bold"
                            v-if="article.product_type == null"
                            >{{
                              $root.percentOff(
                                article.price,
                                article.selling_price,
                                false
                              )
                            }}</span
                          >
                        </p>
                        <!-- <p v-show="article.gross_weight" class="gProductUnit">{{ article.gross_weight + article.unit_of_measure  }}</p> -->
                      </div>
                      <div class="price" v-else>
                        <p>
                          <span class="price">{{
                            article.price | formatMoney
                          }}</span>
                        </p>
                        <!-- <p v-show="article.gross_weight && article.unit_of_measure" class="gProductUnit">{{ article.gross_weight +  article.unit_of_measure }}</p> -->
                      </div>

                      <img
                        class="expressDelivery"
                        v-if="
                          article.express_store.is_express_delivery_available ==
                          true
                        "
                        src="/img/expressDelivery.png"
                        alt
                      />

                      <!-- <div class="size" v-if="article.product_type==null">
                                            <p>Size - <span v-for="option in article.variation"
                                                    v-text="option.configrable_atribute_value"></span> </p>
											</div>-->
                    </div>
                  </div>
                </div>
                <div v-if="product_loader  || store_loader" class="list_product_loader">
									<!-- <loading-icon
										class="loading-icon newLoader"
										name="ball-clip-rotate-multiple"
										color="#ba2126"
										scale="1"
									></loading-icon> -->
                  <div class="productSkeleton row px-4">
                    <div class="col-md-3 col-sm-6 col-xs-6 col-6 pr-0 mb-4 pr-2" v-for="i in 8" :key="i">
                  <PuSkeleton class="Skeletonitem"  height='inherit' />
                    </div>
                  </div>
								</div>
              </div>
			  <paginate
              v-if="this.showPagination == true"
              v-model="page"
              :page-count="pageCount"
              :page-range="4"
              :margin-pages="2"
              :click-handler="product_lazy_loading"
              :prev-text="'Prev'"
              :next-text="'Next'"
              :container-class="'paginateStyle'"
              :page-class="'page-item'"
            >
            </paginate>
		
            </div>
            
            <!-- <pagination v-if="this.$root.isStore == false" v-model="page" :records="totalProducts" :per-page="20" @paginate="product_lazy_loading"/> -->
          </div>
          <!-- <div class="col-md-12">
                    <div class="category-description" v-html="this.description"></div>
					</div>-->
        </div>
      </div>

      <!-- products end -->
      <!-- see other buying otions -->
      <SliderModel
        :items="seeOtherBuyingOptions"
        :isActive="isSeeOtherActive"
      />

      <!-- see other buying otions ends -->
      <div class="product_loader" v-show="pageload === true">
        <!-- <loading-icon
          class="loading-icon newLoader"
          name="ball-clip-rotate-multiple"
          color="#ba2126"
          scale="1"
        ></loading-icon> -->
         <PuSkeleton class="Skeletonitem Skeletonitem3"  height='500px' />
      </div>
    </div>
    <div
      class="modal productCompare"
      :class="{ active: isAddToCart }"
      id="coupon-modal"
    >
      <div class="modal-dialog" style="max-width: 600px">
        <div class="modal-content">
          <div class="modal-body">
            <!-- class="close" -->
            <button
              type="button"
              class="close"
              style="
                margin-top: 0px !important;
                z-index: 999;
                position: absolute;
                top: -5px;
                right: -3px;
              "
              @click="isAddToCart = false"
            >
              &times;
            </button>
            <div class="row m-0">
              <div class="col-md-5 col-6 compareLeft text-center p-4">
                <img src="/" class="img-fluid" alt />
                <p>Cookies</p>
                <!-- <a href="#">View Details</a> -->
              </div>
              <div class="col-md-7 col-6 compareRight">
                <div
                  v-for="(product, i) in productVariation"
                  :key="i"
                  class="row"
                >
                  <div class="col-md-4 text-left">
                    <!-- {{product}} -->
                    <p>{{ product.size }}</p>
                    <p>{{ product.selling_price | formatMoney }}</p>
                    <p>
                      <del>{{ product.price | formatMoney }}</del>
                    </p>
                  </div>
                  <div class="col-md-4 text-center">
                    <span class="px-2 rounded badge-success">40% off</span>
                  </div>
                  <div class="col-md-4 p-0">
                    <div class="control">
                      <div class="qty_box m-auto">
                        <a
                          href="#"
                          :class="{ disabled: qty == 1 }"
                          @click="minQty(i)"
                        >
                          <i class="fa fa-minus"></i>
                        </a>
                        <input
                          type="text"
                          :value="product.quantity"
                          readonly="readonly"
                        />
                        <a href="#" class @click="addQty(i)">
                          <i class="fa fa-plus"></i>
                        </a>
                      </div>
                    </div>
                    <button
                      class="compareBtn mt-3"
                      @click="add_to_cart(product)"
                    >
                      Add to Cart
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- <Login /> -->
          </div>
        </div>
      </div>
    </div>
    <div class="rightFilterWrap forDesktop" :class="{ showFilter: isFilter }">
      <div class="rightFiterContent">
        <div class="filterHeading">
          filters
          <p
            class="float-right mr-3 text-dark cursorPointer"
            @click="isFilter = false"
          >
            &#10005;
          </p>
        </div>
        <div class="filterData">
          <div class="filterDataScroll">
            <div id="accordion" class="accordion-container">
              <div
                class="accordionWrap"
                v-for="(filter, i) in this.storeFilterCategories"
                :key="i"
              >
                <h4
                  class="accordion-title"
                  :class="{ open: i == selectedAccorion }"
                  @click="selectedAccorion = i"
                >
                  <span
                    class="filterCheck"
                    :class="{
                      activeFiterHeader: appliedFilters.includes(
                        filter.id_category
                      ),
                    }"
                    @click="addStoreFilter(filter.id_category)"
                    >&#10003;</span
                  >
                  {{ filter.name }}
                </h4>
                <div
                  class="accordion-content"
                  :class="{ showAccordion: i == selectedAccorion }"
                  v-if="filter.childs"
                >
                  <div v-if="filter.childs">
                    <div
                      @click="addStoreFilter(sub.id_category)"
                      class="filterDiv"
                      :class="{
                        filterSelected: appliedFilters.includes(
                          sub.id_category
                        ),
                      }"
                      v-for="(sub, h) in filter.childs"
                      :key="h"
                    >
                      <span>{{ sub.name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="filterButton">
            <button class="sideFilterClear" @click="removeAllFilters">
              Clear List
            </button>
            <button class="sideFilterMore" @click="getStores()">
              See Nearby Stores
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      v-bind:class="{ active: isStorePopUp === true }"
      id="coupon-modal"
      v-if="isStorePopUp"
    >
      <div class="modal-dialog listStorePopup">
        <div class="modal-content">
          <div class="modal-body">
            <!-- class="close" -->
            <button
              type="button"
              class="close"
              @click="isStorePopUp = false"
              style="
                margin-top: 0px;
                margin-right: 15px;
                z-index: 999;
                top: 15px;
                right: 0px;
                font-size: 25px;
              "
            >
              &times;
            </button>
            <div>
              <div class="storePopupHeading">
                <h3>
                  {{ popUpStores[0].name.replace(/"/g, "").split(",")[0] }}
                </h3>
                <small>{{ popUpStores.length }} Stores near you</small>
              </div>
              <div class="storeWrap">
                <div class="row storePopupDetail">
                  <div class="col-7">
                    <strong>Address</strong>
                  </div>
                  <div class="col-2">
                    <strong>Rating</strong>
                  </div>
                  <div class="col-3">
                    <strong>Distance</strong>
                  </div>
                </div>

                <div
                  class="row storePopupData"
                  v-for="(store, i) in popUpStores"
                  :key="i"
                >
                  <router-link
                    class="col-7 popuplink"
                    :to="{ path: '/store.html', query: { store: store.id } }"
                  >
                    <div style="display: flex; justify-content: space-between">
                      {{
                        store.name
                          .replace(/"/g, "")
                          .substring(store.name.indexOf(",") + 1)
                      }}
                      <img
                        v-if="store.express_store.is_express_delivery_available"
                        height="25"
                        src="/img/expressDelivery.png"
                        alt="Express Delivery"
                      />
                      <img
                        v-if="store.express_store.is_express_delivery_available==false && store.temp_store_close==1"
                        
                        height="25"
                        src="/img/store-closed-icon.png"
                        alt="Express Delivery"
                      />
                    </div>
                  </router-link>
                  <div class="col-2">
                    <i class="fa fa-star"></i>
                    {{ store.ratings.avg_rating }}
                  </div>
                  <div class="col-3">{{ Math.floor(store.distance) }} km</div>
                </div>
              </div>
            </div>
          </div>

          <!-- <Login /> -->
        </div>
      </div>
    </div>
    <!-- <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"></div> -->
  </div>
</template>
<script>
import axios from "axios";
import Card from "./Home/Card.vue";
import SliderModel from "./SlideModel";
import Paginate from "vuejs-paginate";
import { bus } from '../main.js';
export default {
  components: { Card, SliderModel, Paginate },
  name: "Product_list",
  metaInfo() {
    return {
      title: this.meta_title,
      meta: [
        {
          name: "description",
          content: this.meta_description,
        },
        {
          property: "keywords",
          content: this.meta_keyword,
        },
      ],
    };
  },

  data: function () {
    return {
      showPaginationloader:false,
      showPagination:false,
      pageCount: 0,
      otherstorecheck: false,
      storename: "",
      otherstores: [],
      opencheckstorepopupmodal: false,
      diffStore: false,
      store_loader: false,
      busy: false,
      noProduct: false,
      productCompareModal: false,
      isFilter: false,
      itemsToShow: 8,
      selectedAccorion: 0,
      appliedFilters: [],
      isSeeOther: false,
      isAddToCart: false,
      isGrocery: 0,
      isPharmacy:0,
      isPharma: 0,
      activeValue: null,
      isLoading: false,
      storeFliterId: null,
      storeFilterCategories: [],
      // indexAddToCart:'',
      // qty:1,
      meta_title: "",
      description: "",
      meta_description: "",
      meta_keyword: "",
      category_image: "",
      category_mobile_image: "",
      product_loader: true,
      Product_MoreLoad: true,
      filter_error_msg: "",
      filter_status: true,
      mobilefilterActive: "",
      stores: [],
      isSeeOtherActive: false,
      seeOtherBuyingOptions: [],
      isMobile: false,
      blankpage: false,
      page: 1,
      pageload: true,
      pageSize: "",
      service: "category",
      count: 20,
      id_category: this.$route.params.cat_id,
      Product_list: [],
      productVariation: [],
      filters: [],
      filtersAppied: [],
      filterview: [],
      apifilter: "",
      isStorePopUp: false,
      popUpStores: [],
      filter_api_url: [],
      colorsActive: [],
      sizesActive: [],
      sort: [
        { code: "price_low", label: "Price (Low to High)" },
        { code: "selling_price", label: "Price (High to Low)" },
      ],
      select_sort: "product_position",
      select_sort_value: "Newest",
      pass_sort: "",
      pass_url_key: this.$route.params.menu_url_key,

      sort_dir: "desc",
      categorie_name: "",
      current_filter: "",
      Product_count: "",
      get_product_length: "",
      gtm_product_impressions: [],
      productsInWishlist: [],
    };
  },
  methods: {
    CloseDiffStoreCheckPopup() {
      this.diffStore = false;
    },
    check_similar_store(){
        axios
        .get(this.$root.api_url + `/pim/pimresponse.php`, {
          params: {
            service: "similar-stores",
            store_id: this.$route.query.store,
            latitude: this.$root.location.lat,
            longitude: this.$root.location.long,
          },
        })
        .then((response) => {
          
          if (response.data.response.success == 1) {
            this.storename = response.data.result.brandName;
            this.otherstores = response.data.result.stores;


          }
        })
        .catch((error) => {
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
        });
    },

    openotherstoremodal() {
      this.opencheckstorepopupmodal = true;
    },

    showQuantity(id) {
      let bool = false;
      if (this.$root.cart_product.length > 0) {
        bool = this.$root.cart_product.some((x) => x.id_product === id);
      }

      return bool;
    },
    itemInCart(id) {
      let item = {};
      if (this.$root.cart_product.length > 0) {
        item = this.$root.cart_product.find((x) => x.id_product === id);
      }

      return item;
    },
    qty_plus(product, index) {
      // console.log("called plus");
      //   console.log(index);

      // console.log(this.$root.cart_product[index]);
      this.$root.error_message = "";
      this.$root.success_message = "";
      var current_qty = product.qty;
      // console.log(product.max_qty);
      // current_qty < product.max_qty &&
      if (current_qty < 5) {
        this.$root.page_loader = true;
        var form = new FormData();
        form.append("qty_ordered", 1);
        form.append("product_id", product.variant_id);
        form.append("cart_id", product.order_quote_id);
        form.append("pcart", this.$root.pcart);
        form.append("type", "add");
        form.append("item_id", product.item_id);
        form.append("latitude", this.$root.location.lat);
        form.append("longitude", this.$root.location.long);
        // form.append("cart_session",this.$root.cart_session);
        axios
          .post(this.$root.cart_api + "/product/update-product", form)
          .then((response) => {
            if (response.data.success === true) {
              this.$root.page_loader = false;
              //   console.log(this.$root.cart_product[index]);
              // this.$root.cart_product[index]["qty"] =  this.$root.cart_product[index].qty +1
              //  this.$root.cart_total =+product.price
              //     this.$root.cart_subtotal =+ product.selling_price
              //     this.$root.cart_netAmount =+ product.net_amount
              // console.log(this.$root.cart_product[index].qty);
              this.get_cart();

              //   //Code for multi cart add

              //  if(this.$root.pcart===null){
              //      this.$root.pcart = response.data.data.pcart
              //     }

              // if(response.data.data.products.length>0){
              //   //Products Array
              //     let ProductsArray = []
              // Sorting Products array according to SKU
              //    this.$root.cart_total= 0
              //    this.$root.cart_subtotal = 0
              //    this.$root.cart_netAmount = 0
              // response.data.data.forEach(products=>{
              // this.$root.cart_total = this.$root.cart_total + products.grand_total
              // this.$root.cart_subtotal = this.$root.cart_subtotal+ products.order_subtotal
              // this.$root.cart_netAmount = this.$root.cart_netAmount+ products.net_amount

              //     let sortedProducts = this.groupByKey(response.data.data.products, 'sku')
              // // Creating Sorted Products Array
              //         Object.keys(sortedProducts).map(function(key, index) {
              //         ProductsArray.push(sortedProducts[key])
              //         });
              // })
              // console.log(ProductsArray);
              // Modifying Price and Quantity accroding to SKU
              //     let data = []
              //     let price = 0
              //     ProductsArray.forEach((ele,index)=>{

              //      let qty=0
              //         ele.forEach(product=>{
              //             qty = qty + product.qty
              //              ele[0]["qty"] = qty
              //         })
              //         data.push(ele[0])
              //     })
              //     console.log(data);
              //     this.$root.cart_product[index] = data
              // }
              // else{

              //     this.$root.cart_total=response.data.data.grand_total,
              //         // net_amount:response.data.data.net_amount,
              //         this.$root.cart_subtotal=response.data.data.order_subtotal
              //     // products = response.data.data.products
              //     // this.$store.dispatch('getAmount', amount)
              //  this.get_cart()
              //     // this.$root.cart_product = response.data.data.products
              //     //  this.$store.dispatch('getCart', response.data.data.products)
              // }

              // this.$root.cart_product = response.data.data.products;
              // this.$root.cart_total = response.data.data.grand_total;
              // this.$root.cart_subtotal = response.data.data.order_subtotal;
              // this.$root.discount_code = response.data.data.discount_code;
              // this.net_amount = response.data.data.net_amount;
              // this.applied_coupon = response.data.data.discount_code;
              // this.cod_charges = response.data.data.cod_charge;
              // this.shipping_charges = response.data.data.shipping_charges;
              // this.$root.discount_amount = response.data.data.discount_amount;
              // this.$root.success_message = response.data.message;
              // this.$root.error_message = '';
            } else {
              this.$root.page_loader = false;
              this.$toast.error(response.data.message, {
                position: "top",
                duration: 4000,
              });
              // this.$root.error_message = response.data.message;
              this.$root.success_message = "";
              if (response.data.cart_session_status == false) {
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_customer",
                  "",
                  "1y"
                );
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cs",
                  "",
                  "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  "",
                  "1y"
                );
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  "",
                  "1y"
                );
                this.$root.pcart = "";
                this.$root.cart_session = "";
                this.$root.cart_product = [];
              }
            }
          })
          .catch((error) => {
            this.$root.page_loader = false;
            if (error.message === "Network Error") {
              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
            }
            window.scrollTo(0, 0);
          });
      }
    },
    qty_minus(product, index) {
      this.$root.error_message = "";
      this.$root.success_message = "";
      var current_qty = product.qty;
      if (current_qty > 1) {
        // this.$root.cart_product[index].qty = current_qty - 1;
        this.$root.page_loader = true;
        var form = new FormData();
        form.append("qty_ordered", 1);
        form.append("product_id", product.variant_id);
        form.append("cart_id", product.order_quote_id);
        form.append("pcart", this.$root.pcart);
        form.append("type", "remove");
        form.append("item_id", product.item_id);
        form.append("latitude", this.$root.location.lat);
        form.append("longitude", this.$root.location.long);
        axios
          .post(this.$root.cart_api + "/product/update-product", form)
          .then((response) => {
            if (response.data.success === true) {
              this.$root.page_loader = false;

              // this.$root.cart_product[index]["qty"] =  this.$root.cart_product[index].qty - 1
              this.get_cart();
              //Code for multi cart add

              //  if(this.$root.pcart===null){
              //      this.$root.pcart = response.data.data.pcart
              //     }

              // if(response.data.data.length>0){
              //   //Products Array
              //     let ProductsArray = []
              //     // Sorting Products array according to SKU
              //    this.$root.cart_total= 0
              //    this.$root.cart_subtotal = 0
              //    this.$root.cart_netAmount = 0
              //     response.data.data.forEach(products=>{
              //         this.$root.cart_total = this.$root.cart_total + products.grand_total
              //         this.$root.cart_subtotal = this.$root.cart_subtotal+ products.order_subtotal
              //         this.$root.cart_netAmount = this.$root.cart_netAmount+ products.net_amount

              //         let sortedProducts = this.groupByKey(products.products, 'sku')
              //     // Creating Sorted Products Array
              //             Object.keys(sortedProducts).map(function(key, index) {
              //             ProductsArray.push(sortedProducts[key])
              //             });
              //     })

              //     // Modifying Price and Quantity accroding to SKU
              //     let data = []
              //     let price = 0
              //     ProductsArray.forEach((ele,index)=>{
              //      let qty=0
              //         ele.forEach(product=>{
              //             qty = qty + product.qty
              //              ele[0]["qty"] = qty
              //         })
              //         data.push(ele[0])
              //     })
              //     this.$root.cart_product = data
              // }
              // else{

              //     this.$root.cart_total=response.data.data.grand_total,
              //         // net_amount:response.data.data.net_amount,
              //         this.$root.cart_subtotal=response.data.data.order_subtotal
              //     // products = response.data.data.products
              //     // this.$store.dispatch('getAmount', amount)
              //  this.get_cart()
              //     // this.$root.cart_product = response.data.data.products
              //     //  this.$store.dispatch('getCart', response.data.data.products)
              // }
              // this.$root.cart_product = response.data.data.products;
              // this.$root.cart_total = response.data.data.grand_total;
              // this.net_amount = response.data.data.net_amount;
              // this.$root.cart_subtotal = response.data.data.order_subtotal;
              // this.$root.discount_code = response.data.data.discount_code;
              // this.cod_charges = response.data.data.cod_charge;
              // this.shipping_charges = response.data.data.shipping_charges;
              // this.applied_coupon = response.data.data.discount_code;
              // this.$root.discount_amount = response.data.data.discount_amount;
              this.$toast.success(response.data.message, {
                position: "top",
                duration: 4000,
              });
              // this.$root.success_message = response.data.message;
              this.$root.error_message = "";
            } else {
              this.$root.page_loader = false;
              this.$toast.error(response.data.message, {
                position: "top",
                duration: 4000,
              });
              // this.$root.error_message = response.data.message;
              this.$root.success_message = "";
              if (response.data.cart_session_status == false) {
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_customer",
                  "",
                  "1y"
                );
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cs",
                  "",
                  "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  "",
                  "1y"
                );
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  "",
                  "1y"
                );
                this.$root.pcart = "";
                this.$root.cart_session = "";
                this.$root.cart_product = [];
              }
            }
          })
          .catch((error) => {
            this.$root.page_loader = false;
            if (error.message === "Network Error") {
              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
            }
            window.scrollTo(0, 0);
          });
      }
    },
    get_cart: function () {
      if (this.$root.pcart != null && this.$root.pcart != "") {
        var form = new FormData();
        form.append("pcart", this.$root.pcart);
        form.append("cart_session", this.$root.cart_session);
        axios
          .post(this.$root.cart_api + "/cart/get-cart", form)
          .then((response) => {
            if (response.data.success === true) {
              this.$root.shipping_charge = response.data.shippingCharge;
              this.$root.cart_total = response.data.grandTotal;
              this.$root.cart_subtotal = response.data.subTotal;
              this.$root.cart_netAmount = response.data.netAmount;
              this.$root.discount_amount = response.data.discountAmount;

              if (this.$root.pcart === null) {
                this.$root.pcart = response.data.pcart;
              }
              if (response.data.data.length > 0) {
                let ProductsArray = [];
                // Sorting Products array according to SKU

                response.data.data.forEach((cart) => {
                  ProductsArray = [...ProductsArray, ...cart.products];

                  if (cart.cookieDelete === 1) {
                    $cookies.set(
                      window.location.hostname.substring(10, 4) + "_cart",
                      ""
                    );
                    this.$root.pcart = "";
                  }
                });

                this.$root.cart_product = ProductsArray;
                // this.getCouponList();
              } else {
                this.$root.cart_product = [];
                this.$root.shipping_charge = response.data.shippingCharge;
                this.$root.cart_total = response.data.grandTotal;
                this.$root.cart_subtotal = response.data.subTotal;
                this.$root.cart_netAmount = response.data.netAmount;
                this.$root.discount_amount = response.data.discountAmount;

                //  this.$store.dispatch('getCart', response.data.data.products)
              }

              // if (response.data.data.cookieDelete === 1) {
              // 	$cookies.set(
              // 		window.location.hostname.substring(10, 4) + "_cart",
              // 		""
              // 	);
              // 	this.$root.pcart = "";
              // }
              // if(this.$root.address.length != 0){
              //   for(let i = 0; i < this.$root.address.length; i++){
              //     if(i == 0)
              //     {
              //       this.$root.address_id = this.$root.address[i].id*1;
              //       this.$root.select_address_no = i;
              //     }
              //   }
              // }
            } else {
              if (
                response.data.customer_session_status == false ||
                response.data.cart_session_status == false
              ) {
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_customer",
                  "",
                  "1y"
                );
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cs",
                  "",
                  "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  "",
                  "1y"
                );
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  "",
                  "1y"
                );
                this.$root.pcart = "";
                this.$root.cart_session = "";
                this.$root.cart_product = [];
              }
            }
          })
          .catch((error) => {
            if (error.message === "Network Error") {
              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
            }
            window.scrollTo(0, 0);
          });
      }
    },
    toggleStores() {
      //  console.log("test")
      this.$root.isStore = true;
      // if (this.stores.length == 0) {
      //   console.log("test123")
      //   this.getAllStores();
      // }
    },
    toggleProducts() {
      this.$root.isStore = false;
      // if (this.Product_list.length == 0) {
      //   this.getProductList();
      // }
    },
    checkProductStatus() {
      if (this.Product_list.length == 0 && this.stores.length == 0) {
        this.noProduct = true;
      } else {
        this.noProduct = false;
      }
    },
    closeFilter() {
      this.isFilter = false;
    },
    removeAllFilters() {
      this.appliedFilters = [];
      this.apiFilter = "";
      this.isFilter = false;
      this.getStores();
    },
    addStoreFilter(id, isApply) {
      if (this.appliedFilters.includes(id)) {
        let filtersApplied = this.arrayRemove(this.appliedFilters, id);
        this.appliedFilters = filtersApplied;
      } else {
        this.appliedFilters.push(id);
      }
      this.apiFilter = this.appliedFilters.join(",");
      if (isApply) {
        this.getStores();
      }

      this.getStores();
    },
    arrayRemove(arr, value) {
      return arr.filter(function (ele) {
        return ele != value;
      });
    },
    getStores() {
      if (this.$route.query.isFromStore) {
        this.getProductListStore();
      } else {
        this.getProductList();
      }
    },

    // addStoreFilter(id) {
    //   (this.storeFliterId = id), this.getProductList();
    // },
    storePopUpHandler(stores) {
      // console.log(stores);
      this.popUpStores = stores;
      this.isStorePopUp = true;
    },
    addQty(index) {
      this.productVariation[index].quantity++;
    },
    minQty(index) {
      if (this.productVariation[index].quantity > 1) {
        this.productVariation[index].quantity--;
      }
    },
    getWish() {
      this.$root.breadcrumb = "";
      this.$root.page_loader = true;
      var form = new FormData();
      if (this.$root.customer_id && this.$root.customer_session) {
        form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        form.append("type", "get");
        axios
          .post(this.$root.cart_api + `/wishlist/items`, form)
          .then((response) => {
            this.$root.page_loader = false;
            if (response.data.success == true) {
              if (response.data.data == 0) {
                this.$root.wishListProducts = 0;
              }
              this.wishlistProduct = response.data.data;
              if (response.data.data) {
                this.productsInWishlist = response.data.data.map((product) => {
                  return product.id_product;
                });
              }
              this.$root.page_loader = false;
            } else {
              this.$root.page_loader = false;
              if (response.data.data.customer_session_status == false) {
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_customer",
                  "",
                  "1y"
                );
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cs",
                  "",
                  "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
              }
            }
          })
          .catch((error) => {
            this.$root.page_loader = false;
          });
      } else {
        this.$root.page_loader = false;
      }
    },
    getVariations(product) {
      // this.$root.page_loader = true;
      console.log("product", product);
      axios
        .get(this.$root.api_url + `/pim/pimresponse.php`, {
          params: {
            service: "product_variation_options",

            group_id: product.group_id,
            id_product: product.id_product,
            source_product_id: product.source_product_id,
            store: product.store,
            url_key: product.url_key,
            sort_by: this.pass_sort,
            sort_dir: this.sort_dir,
            filter: this.apifilter,
            latitude: this.$root.location.lat,
            longitude: this.$root.location.long,
          },
        })
        .then((response) => {
          if (response.data.result.variations.length > 1) {
            console.log("variations", response.data.result.variations);
            this.add_to_cart(response.data.result.variations[0]);
            // this.isAddToCart = true;
            // this.productCompareModal = true;
            // this.productVariation = response.data.result.variations;
          } else {
            this.add_to_cart(response.data.result.variations[0]);
            console.log("variations", response.data.result.variations[0]);
          }

          // this.productVariation = response.data.result.variations;
          this.$root.page_loader = false;
          // console.log(seeOtherBuyingOptions);
        })
        .catch((error) => {
          this.$root.page_loader = false;
        });
    },
    wishlistHandler(id) {
      if (this.productsInWishlist.includes(parseInt(id))) {
        this.remove_w(id);
      } else {
        this.addToWishList(id);
      }
    },
    addToWishList(id) {
      if (!this.$root.customer_id) {
        this.$root.login_popup = true;
      } else {
        var form = new FormData();
        form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        form.append("type", "add");
        form.append("product_id", id);
        axios
          .post(this.$root.cart_api + `/wishlist/add-to-wishlist`, form)
          .then((res) => {
            if (res.data.success) {
              // console.log("called");
              this.productsInWishlist.push(parseInt(id));
              // this.$root.success_message = res.data.message
              // this.$root.wishListProducts = res.data.data
              this.$root.wishListProducts = this.$root.wishListProducts + 1;
              this.$toast.success(res.data.message, {
                position: "top-right",
                duration: 4000,
              });
            } else {
              // this.productsInWishlist.forEach(e => console.log('hekki', e))

              // console.log(arr);
              this.$toast.error("Product already exits in wishlist", {
                position: "top-right",
                duration: 4000,
              });
            }
          })
          .catch((err) => {
            this.$toast.error("Something went wrong", {
              position: "top-right",
              duration: 4000,
            });
            //this.$root.error_message = err.data.message
          });
      }
      // console.log(id);
    },
    remove_w(id) {
      var form = new FormData();
      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      form.append("product_id", id);
      form.append("type", "remove");
      axios
        .post(this.$root.cart_api + `/wishlist/remove-product`, form)
        .then((response) => {
          if (response.data.success == true) {
            this.productsInWishlist = this.productsInWishlist.filter(
              (el) => parseInt(el) !== parseInt(id)
            );
            if (this.$root.wishListProducts > 0) {
              this.$root.wishListProducts = this.$root.wishListProducts - 1;
            }
            this.$toast.success(response.data.message, {
              position: "top-right",
              duration: 4000,
            });
          } else {
            this.$root.page_loader = false;
            if (response.data.data.customer_session_status == false) {
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_customer",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cus_sess",
                "",
                "1y"
              );
              this.$root.customer_id = "";
              this.$root.customer_session = "";
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_ct_sess",
                "",
                "1y"
              );
              this.$root.cart_id = "";
              this.$root.cart_session = "";
              this.$root.cart_product = [];
            }
          }
        });
    },
    getSeeOtherBuyingOptions(product) {
      this.$root.page_loader = true;

      axios
        .get(this.$root.api_url + `/pim/pimresponse.php`, {
          params: {
            service: "other_buying_options",

            group_id: product.group_id,
            id_product: product.id_product,
            source_product_id: product.source_product_id,
            store: product.store,
            url_key: product.url_key,
            sort_by: this.pass_sort,
            sort_dir: this.sort_dir,
            filter: this.apifilter,
            latitude: this.$root.location.lat,
            longitude: this.$root.location.long,
          },
        })
        .then((response) => {
          // console.log(response.data.result);
          this.isSeeOtherActive = true;
          this.seeOtherBuyingOptions =
            response.data.result.other_available_buyers;
          this.$root.page_loader = false;
          // console.log(seeOtherBuyingOptions);
        })
        .catch((error) => {
          this.$root.page_loader = false;
        });
    },
    getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
      var R = 6371; // Radius of the earth in km
      var dLat = this.deg2rad(lat2 - lat1); // this.deg2rad below
      var dLon = this.deg2rad(lon2 - lon1);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(lat1)) *
          Math.cos(this.deg2rad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c; // Distance in km
      return d;
    },

    deg2rad(deg) {
      return deg * (Math.PI / 180);
    },
    groupByKey(array, key) {
      return array.reduce((hash, obj) => {
        if (obj[key] === undefined) return hash;
        return Object.assign(hash, {
          [obj[key]]: (hash[obj[key]] || []).concat(obj),
        });
      }, {});
    },
    add_to_cart: function (product) {
      console.log("product", product);
      this.$root.pcart = $cookies.get(
        window.location.hostname.substring(10, 4) + "_cart"
      );

      // this.$root.page_loader = true;
      var form = new FormData();
      form.append("product_id", product.id_product || product.size.variant_id);
      form.append("product_parent_id", product.parent_id || null);
      form.append("product_options", product.size || null);
      form.append("name", product.name);
      form.append("sku", product.sku || product.size.sku);
      form.append("master_sku", product.sku || product.size.sku);
      form.append("price", product.price);
      form.append("qty_ordered", 1);
      form.append("final_price", product.selling_price);
      form.append("store", product.store);
      form.append("gi", product.group_id);
      form.append("ig", this.isGrocery);
     
      // console.log("added");
      // check for stores
      // form.append("s", [product.stores]);
      // if (store) {
      // 	form.append("store", product.store);
      // } else {
      // 	form.append("store", this.$route.query.store);
      // }
      // form.append("store", this.$route.query.store);

      form.append("latitude", this.$root.location.lat);
      form.append("longitude", this.$root.location.long);
      // form.append('pcart',0)
      // console.log(this.$root.cart_product.length);
      if (this.$root.cart_product.length == 0 && !this.$root.pcart) {
        form.append("pcart", 0);
      } else {
        form.append("pcart", this.$root.pcart);
      }

      if (this.$root.customer_id) {
        form.append("customer_id", this.$root.customer_id);
      }
      if (this.$root.customer_session) {
        form.append("customer_session", this.$root.customer_session);
      }

      // if (this.$root.pcart != null && this.$root.pcart != '') {
      //     form.append("pcart", this.$root.pcart);
      //     form.append("cart_session", this.$root.cart_session);
      // }
      // if (this.$root.customer_id != null && this.$root.customer_id != '') {
      //     form.append("customer_id", this.$root.customer_id);
      //     form.append("customer_session", this.$root.customer_session);
      // }
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      axios
        .post(this.$root.cart_api + "/product/add-product", form, config)
        .then((response) => {
          // console.log("calledww");
          if (response.data.success === true) {
            if (this.$root.numberOfStores < response.data.data.length) {
                this.diffStore=true;
                // this.$toast.success("You have added an item from a different store. Shipping charges may vary accordingly.", {
                //   position: "top",
                //   duration: 1000*300,
                // });
                // this.$toast.success("Product added to cart", {
                //   position: "top",
                //   duration: 4000,
                // });
                bus.$emit('buyingfromotherstores', 'You have added an item from a different store. Shipping charges may vary accordingly');
                // this.$toast.success("Product added to cart", {
                //   position: "top",
                //   duration: 4000,
                //   dismissable : false
                // });
                // this.toastMessage = true;
                
              } else {
                this.$toast.success("Product added to cart", {
                  position: "top",
                  duration: 4000,
                });
              }
            this.isAddToCart = false;
            // console.log("added");

            // this.size = {
            // 	select_size: "",
            // 	max_qty: "1",
            // 	variant_id: "",
            // 	sku: "",
            // };
            this.qty = 1;

            // this.$root.success_message = response.data.message;
            this.$root.error_message = "";
            this.$root.page_loader = false;
            // this.$root.cart_product = response.data.data.products;
            this.$root.cart_total = response.data.data.grand_total;
            this.$root.cart_subtotal = response.data.data.order_subtotal;
            this.$root.discount_code = response.data.data.discount_code;
            this.$root.discount_amount = response.data.data.discount_amount;
            this.$root.address = response.data.data.address;

            //Code for multi cart add
            // console.log($cookies.get(window.location.hostname.substring(10, 4) + '_cart'));
            // if(this.$root.pcart!=response.data.data.pcart){
            //       this.$root.pcart = response.data.data.pcart
            //      $cookies.set(window.location.hostname.substring(10, 4) + '_cart', response.data.data.pcart, "1y");
            // }
            // console.log(response.data.data[0].pcart);

            // this.$root.pcart == "undefined"
            if (
              !this.$root.pcart &&
              this.$root.pcart != response.data.data.pcart
            ) {
              // console.log("pcart");
              this.$root.pcart = response.data.data.pcart;
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                response.data.data.pcart,
                "1y"
              );
            } else {
              // console.log(response);

              this.$root.pcart = response.data.pcart;
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                response.data.pcart,
                "1y"
              );
            }

            if (response.data.data.length > 0) {
              this.$root.numberOfStores = response.data.data.length;
              //Products Array
              let ProductsArray = [];
              // Sorting Products array according to SKU
              this.$root.cart_total = 0;
              this.$root.cart_subtotal = 0;
              this.$root.cart_netAmount = 0;
              response.data.data.forEach((products) => {
                this.$root.cart_total =
                  this.$root.cart_total + products.grand_total;
                this.$root.cart_subtotal =
                  this.$root.cart_subtotal + products.order_subtotal;
                this.$root.cart_netAmount =
                  this.$root.cart_netAmount + products.net_amount;

                let sortedProducts = this.groupByKey(products.products, "sku");
                // Creating Sorted Products Array
                Object.keys(sortedProducts).map(function (key, index) {
                  ProductsArray.push(sortedProducts[key]);
                });
              });

              // Modifying Price and Quantity accroding to SKU
              let data = [];
              let price = 0;
              ProductsArray.forEach((ele, index) => {
                let qty = 0;
                ele.forEach((product) => {
                  qty = qty + product.qty;
                  ele[0]["qty"] = qty;
                });
                data.push(ele[0]);
              });
              this.$root.cart_product = data;

              if (this.isBuyNow) {
                this.$router.push("/checkout.html");
              }
            } else {
              // console.log("called else");
              this.$root.pcart = response.data.data.pcart;
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                response.data.data.pcart,
                "1y"
              );

              (this.$root.cart_total = response.data.data.grand_total),
                // net_amount:response.data.data.net_amount,
                (this.$root.cart_subtotal = response.data.data.order_subtotal);
              // products = response.data.data.products
              // this.$store.dispatch('getAmount', amount)

              this.$root.cart_product = response.data.data.products;
              if (this.isBuyNow) {
                this.$router.push("/checkout.html");
              }
              //  this.$store.dispatch('getCart', response.data.data.products)
            }

            
            // this.$root.minicart = false; //code commented to not open minicart when product add to cart

            // this.$root.pcart = response
            // if (this.$root.address.length != 0) {
            //     for (let i = 0; i < this.$root.address.length; i++) {
            //         if (i == 0) {
            //             this.$root.address_id = this.$root.address[i].id * 1;
            //             this.$root.select_address_no = i;
            //         }
            //     }
            // }

            // this.$root.pcart = response.data.data.pcart;
            this.$root.thankyou_cart = response.data.data.pcart;
            if (response.data.data.cart_session) {
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_carts",
                response.data.data.cart_session,
                "1y"
              );
              this.$root.cart_session = response.data.data.cart_session;
            }
            // if (event.target.title === "Buy now") {
            //     this.$gtm.trackEvent({
            //         event: 'addToCart',
            //         category: 'Ecommerce',
            //         action: 'Buy_now',
            //         label: this.name,
            //         ecommerce: {
            //             currencyCode: 'INR',
            //             add: {
            //                 product: [{
            //                     name: this.name,
            //                     id: this.master_sku,
            //                     price: this.selling_price,
            //                     variant: this.size.select_size,
            //                     quantity: this.qty,
            //                     category: this.product_cat,
            //                 }
            //                 ]
            //             }
            //         }
            //     });
            //     setTimeout(() => this.$gtm.trackEvent({

            //         event: 'checkout',
            //         category: 'Ecommerce',
            //         action: 'Buy_now',
            //         label: '1',
            //         ecommerce: {
            //             checkout: {
            //                 'actionField': { 'step': 1, 'option': this.$root.login_status },
            //                 product: this.$root.gtm_product,
            //             }
            //         }
            //     }), 100);

            //     this.$router.push('checkout.html');
            // }
            // else {
            //     this.$root.minicart = false;
            //     this.size_active = true;
            //     this.$gtm.trackEvent({
            //         event: 'addToCart',
            //         category: 'Ecommerce',
            //         action: 'Add_to_cart',
            //         label: this.name,
            //         ecommerce: {
            //             currencyCode: 'INR',
            //             add: {
            //                 product: [{
            //                     name: this.name,
            //                     id: this.master_sku,
            //                     price: this.selling_price,
            //                     variant: this.size.select_size,
            //                     quantity: this.qty,
            //                     category: this.product_cat,
            //                 }
            //                 ]
            //             }
            //         }
            //     });
            // }

            // this.size.select_size = "";
          } else {
            this.$root.success_message = "";
            this.$toast.error(response.data.message, {
              position: "top-right",
              duration: 4000,
            });
            // this.$root.error_message = response.data.message;
            this.$root.page_loader = false;
            if (response.data.cart_session_status == false) {
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_carts",
                "",
                "1y"
              );
              this.$root.pcart = "";
              this.$root.cart_session = "";
              this.$root.cart_product = [];
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.$root.page_loader = false;
          // this.$root.error_message = error.message;
          // window.scrollTo(0, 0);
        });
      // } else {
      // 	this.size_active = false;
      // 	this.size_error = "Please select a size first";
      // }
    },
    toggleFilters(index) {
      this.activeValue = index;
    },
    // toggleSeeOtherBuying(product) {
    // 	console.log(product.other_available_buyers);
    // 	this.isSeeOtherActive = true;

    // 	this.seeOtherBuyingOptions = product.other_available_buyers;
    // },
    gtm_product_click: function (name, id, price, category, position) {
      // this.$gtm.trackEvent({
      //     event: 'productClick',
      //     category: 'pdp',
      //     action: 'productClick',
      //     label: 'Product List page',
      //     pdp: {
      //         click: {
      //             actionField: { list: this.categorie_name },
      //             product: [{
      //                 name: name,
      //                 id: id,
      //                 price: price,
      //                 category: category,
      //                 position: position + 1
      //             }]
      //         }
      //     }
      // });
    },
    filterActive: function (item) {
      return this.mobilefilterActive === item;
    },
    close_mobile_filter: function () {
      this.filter_status = false;
    },
    toggle: function (event) {
      event.target.classList.toggle("active");
      if (screen.width < 768) {
        this.mobilefilterActive = event.target.text;
      }
    },
    filter_show: function () {
      this.filter_status = true;
    },
    getAllStores() {
      
      this.store_loader = true;
      
      axios
        .get(this.$root.api_url + `/pim/pimresponse.php`, {
          params: {
            service: "store_list",
            url_key: this.pass_url_key,
            latitude: this.$root.location.lat,
            longitude: this.$root.location.long,
            sq: this.$route.query.sq,
          },
        })

        .then((response) => {
          console.log("Testing", response.data.result);
          this.store_loader = false;
          this.pageload = false;

          this.$root.page_loader = false;

          let stores = response.data.result;
          stores.map((store, i) => {
            this.stores.push(store);
          });

          this.checkProductStatus();
        })
        .catch((error) => {
          this.checkProductStatus();
          this.store_loader = false;
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
        });
    },
    async getProductList() {
      
      await this.getWish();
     
      console.log("get product list")
      // if(this.$root.isStore) {
      //   this.product_loader = true
      // } else {}

      if (this.$route.name === "collections") {
        this.service = "collections";
        this.pass_url_key = this.$route.params.url_key;
      }

      this.filter_error_msg = "";
      if (this.Product_MoreLoad === true) {
        console.log("api call if getproduct list")
        this.$root.error_message = "";
        this.$root.success_message = "";
        this.Product_MoreLoad = false;
        // this.getAllStores()

        axios
          // .get(this.$root.api_url + `/pim/pimresponse.php`, {
          .get(this.$root.api_url + `/pim/pimresponse.php`, {
            params: {
              service: this.service,
              category: this.$route.query.category,
              store: this.store,
              url_key: this.pass_url_key,
              page: this.page,
              count: this.count,
              sort_by: this.pass_sort,
              sort_dir: this.sort_dir,
              filter: this.apifilter,
              subcat_ids: this.appliedFilters,
              // latitude: 28.5758268,
              // longitude: 77.3209443,
              latitude: this.$root.location.lat,
              longitude: this.$root.location.long,
              sq: this.$route.query.sq,
            },
          })

          .then((response) => {
            this.category_image = response.data.result.image;
            this.$root.title = response.data.result.name;
            this.category_mobile_image = response.data.result.mobile_image;
            if (response.data.response.success === 1) {
               if(response.data.result.count>20){
                this.showPagination=true;
                this.pageCount = Math.ceil(response.data.result.count/20);
              }
               if(this.$route.query.page){
                 if(this.$route.query.page > this.pageCount){
                    this.page=this.pageCount
                     this.$router.push({
                       query: { ...this.$route.query, page: this.page },
                     });
                     this.Product_MoreLoad = true;z
                      return this.getProductList();
                      // return this.product_lazy_loading();
                      
                      
                 }
               }
               this.product_loader = false;
              
              
              this.category_mobile_image = response.data.result.mobile_image;
              if (response.data.result.products.length === 0) {
                this.filter_error_msg =
                  "No product found, please try by removing last applied filter.";
              }
              this.storeFilterCategories = response.data.result.subcatlist;

              this.isGrocery = response.data.result.is_groceries ? 1 : 0;
              this.isPharmacy = response.data.result.is_pharmacy ? 1 : 0;
              
              this.description = response.data.result.description;
              this.meta_title = response.data.result.meta_title;
              this.meta_description = response.data.result.meta_description;
              this.meta_keyword = response.data.result.meta_keyword;
              this.category_image = response.data.result.image;
              this.category_mobile_image = response.data.result.mobile_image;
              // this.Product_list = [];

              // this.stores = response.data.result.stores;
              // let stores = response.data.result.stores;
              // stores.map((store, i) => {
              //   let distance = this.getDistanceFromLatLonInKm(
              //     this.$root.location.lat,
              //     this.$root.location.long,
              //     // position.coords.latitude,
              //     // position.coords.longitude,
              //     store.latitude,
              //     store.longitude
              //   );

              //   store.distance = distance.toFixed(2);

              //   store.all_stores.map((store, i) => {
              //     let distance = this.getDistanceFromLatLonInKm(
              //       this.$root.location.lat,
              //       this.$root.location.long,
              //       // position.coords.latitude,
              //       // position.coords.longitude,
              //       store.latitude,
              //       store.longitude
              //     );

              //     store.distance = distance.toFixed(2);
              //   });

              //   this.stores.push(store);
              // });

              this.Product_list = response.data.result.products;

              // this.gtm_product_impressions = [];

              // for (let i = 0; i < response.data.result.products.length; i++) {
              //   let name = response.data.result.products[i].name;
              //   let id = response.data.result.products[i].sku;
              //   let price = response.data.result.products[i].selling_price;
              //   let category = response.data.result.products[i].category;
              //   let list = response.data.result.name;
              //   let position = i + 1;
              //   this.gtm_product_impressions.push({
              //     name,
              //     id,
              //     price,
              //     category,
              //     list,
              //     position,
              //   });
              // }

              // this.$gtm.trackEvent({
              //     event: 'impressionSent',
              //     category: 'Listing',
              //     action: 'Product Impression',
              //     label: 'Product List page',
              //     listing: {
              //         currencyCode: 'INR',
              //         product: this.gtm_product_impressions
              //     }
              // });

              this.filters = response.data.result.filters;
              this.mobilefilterActive =
                response.data.result.filters[0].filter_lable;
              this.sort = this.sort.concat(response.data.result.sort);
              this.categorie_name = response.data.result.name;
              this.$root.breadcrumb = response.data.result.name;
              this.$root.breadcrumb_second.name =
                response.data.result.parent_name;
              this.$root.breadcrumb_second.url =
                response.data.result.parent_url_key;
              this.Product_count = response.data.result.count;
              this.pageSize = response.data.result.count / this.count;
              this.get_product_length = response.data.result.products.length;
              
              // Check for this function
              if (this.wishlistProduct != undefined) {
                this.Product_list.map((e) => {
                  let index = this.wishlistProduct.findIndex((el) => {
                    if (el.id_product == e.id_product) {
                      return el;
                    }
                  });
                  if (index > -1) {
                    // console.log(index);
                    return (this.Product_list[index].addedWish = true);
                  } else {
                    return (e.addedWish = false);
                  }
                });
              }
              if (this.get_product_length >= this.count) {
                //  console.log(this.get_product_length,"this lenght",this.count);
                // this.page++;
                this.Product_MoreLoad = true;
              } else {
                this.product_loader = false;
              }
              this.checkProductStatus();
              this.pageload = false;
            } else {
              this.checkProductStatus();
              this.showPagination=false;
              this.$root.error_message = response.data.response.error_message;
              this.product_loader = false;
              this.blankpage = true;
              this.pageload = false;
            }
          })
          .catch((error) => {
            if (error.message === "Network Error") {
              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
            }
          });
      }
    },

    getProductListStore() {
      console.log(this.product_loader)
		console.log("getProductListStore")
      this.pageload = false;
      if (this.$route.name === "collections") {
        this.service = "collections";
        this.pass_url_key = this.$route.params.url_key;
      }
      this.pass_url_key = "all";

      this.filter_error_msg = "";
      if (this.Product_MoreLoad === true) {
        this.$root.error_message = "";
        this.$root.success_message = "";
        this.Product_MoreLoad = false;

        axios
          .get(this.$root.api_url + `/pim/pimresponse.php`, {
            params: {
              service: "storeProducts",
              store: this.$route.query.store,
              category: this.$route.query.category,
              url_key: this.$route.query.url_key
                ? this.$route.query.url_key
                : "all",
              page: this.page,
              count: this.count,
              sort_by: this.pass_sort,
              sort_dir: this.sort_dir,
              filter: this.apifilter,
              sq: this.$route.query.sq,
              latitude: this.$root.location.lat,
              longitude: this.$root.location.long,
            },
          })

          .then((response) => {
            if (response.data.response.success === 1) {
              this.product_loader = false;
              if(response.data.result.count>20){
                this.showPagination=true;
                this.pageCount = Math.ceil(response.data.result.count/20);
              }
              if(this.$route.query.page){
                 if(this.$route.query.page > this.pageCount){
                    this.page=this.pageCount
                     this.$router.push({
                       query: { ...this.$route.query, page: this.page },
                     });
                     this.Product_MoreLoad = true;
                      return this.getProductListStore(); 
                 }
               }

              if (response.data.result.products.length === 0) {
                this.filter_error_msg =
                  "No product found, please try by removing last applied filter.";
              }
              this.isGrocery = response.data.result.is_groceries ? 1 : 0;
              this.isPharmacy = response.data.result.is_pharmacy ? 1 : 0;
              this.description = response.data.result.description;
              this.meta_title = response.data.result.meta_title;
              this.meta_description = response.data.result.meta_description;
              this.meta_keyword = response.data.result.meta_keyword;
              this.category_image = response.data.result.image;
              this.category_mobile_image = response.data.result.mobile_image;
            //   this.Product_list = [];
            //   this.Product_list = this.Product_list.concat(
            //     response.data.result.products
            //   );
			        this.Product_list = response.data.result.products;
              this.gtm_product_impressions = [];

              for (let i = 0; i < response.data.result.products.length; i++) {
                let name = response.data.result.products[i].name;
                let id = response.data.result.products[i].sku;
                let price = response.data.result.products[i].selling_price;
                let category = response.data.result.products[i].category;
                let list = response.data.result.name;
                let position = i + 1;
                this.gtm_product_impressions.push({
                  name,
                  id,
                  price,
                  category,
                  list,
                  position,
                });
              }

              // this.$gtm.trackEvent({
              //     event: 'impressionSent',
              //     category: 'Listing',
              //     action: 'Product Impression',
              //     label: 'Product List page',
              //     listing: {
              //         currencyCode: 'INR',
              //         product: this.gtm_product_impressions
              //     }
              // });

              this.filters = response.data.result.filters;
              this.mobilefilterActive =
                response.data.result.filters[0].filter_lable;
              this.sort = this.sort.concat(response.data.result.sort);
              this.categorie_name = response.data.result.name;
              this.$root.breadcrumb = response.data.result.name;
              this.$root.breadcrumb_second.name =
                response.data.result.parent_name;
              this.$root.breadcrumb_second.url =
                response.data.result.parent_url_key;
              this.Product_count = response.data.result.count;
              this.pageSize = response.data.result.count / this.count;
              this.get_product_length = response.data.result.products.length;
              if (this.get_product_length >= this.count) {
                // this.page++;
                this.Product_MoreLoad = true;
              } else {
                this.product_loader = false;
              }
              this.checkProductStatus();
            } else {
              this.checkProductStatus();
              this.showPagination=false;
              this.$root.error_message = response.data.response.error_message;
              this.product_loader = false;
              this.blankpage = true;
              this.pageload = false;
            }
          })
          .catch((error) => {
            if (error.message === "Network Error") {
              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
            }
          });
      }
    },
    product_lazy_loading_store() {
      this.$root.page_loader = true;
      console.log("product_lazy_loading_store");
      this.filter_error_msg = "";
      if (this.Product_MoreLoad === true && this.page != 1) {
        this.product_loader = true;
        this.$root.error_message = "";
        this.$root.success_message = "";
        this.Product_MoreLoad = false;
        axios
          .get(this.$root.api_url + `/pim/pimresponse.php`, {
            params: {
              service: "storeProducts",
              store: this.$route.query.store,
              category: this.$route.query.category,
              url_key: this.$route.query.url_key
                ? this.$route.query.url_key
                : "all",
              page: this.page,
              count: this.count,
              sort_by: this.pass_sort,
              sort_dir: this.sort_dir,
              filter: this.apifilter,
              sq: this.$route.query.sq,
              latitude: this.$root.location.lat,
              longitude: this.$root.location.long,
            },
          })

          .then((response) => {
            if (response.data.response.success === 1) {
              this.product_loader = false;
              if (response.data.result.products.length === 0) {
                this.filter_error_msg =
                  "No product found, please try by removing last applied filter.";
              }
              this.meta_title = response.data.result.meta_title;
              this.meta_description = response.data.result.meta_description;
              this.meta_keyword = response.data.result.meta_keyword;
              this.Product_list = response.data.result.products;
              this.$root.page_loader = false;
              // this.Product_list = this.Product_list.concat(
              // 	response.data.result.products
              // );
              this.gtm_product_impressions = [];
              for (let i = 0; i < response.data.result.products.length; i++) {
                let name = response.data.result.products[i].name;
                let id = response.data.result.products[i].sku;
                let price = response.data.result.products[i].selling_price;
                let category = response.data.result.products[i].category;
                let list = response.data.result.name;
                let position = i + 1;
                this.gtm_product_impressions.push({
                  name,
                  id,
                  price,
                  category,
                  list,
                  position,
                });
              }
              // this.$gtm.trackEvent({
              //     event: 'impressionSent',
              //     category: 'Listing',
              //     action: 'Product Impression',
              //     label: 'Product List page',
              //     listing: {
              //         currencyCode: 'INR',
              //         product: this.gtm_product_impressions
              //     }
              // });
              this.filters = response.data.result.filters;
              this.mobilefilterActive =
                response.data.result.filters[0].filter_lable;
              this.categorie_name = response.data.result.name;
              this.Product_count = response.data.result.count;
              this.pageSize = response.data.result.count / this.count;
              this.get_product_length = response.data.result.products.length;
              this.pageload = false;
              if (this.get_product_length >= this.count) {
                // this.page++;
                this.Product_MoreLoad = true;
              } else {
                this.product_loader = false;
              }
            } else {
              this.$root.error_message = response.data.response.error_message;
              this.product_loader = false;
              this.blankpage = true;
              this.pageload = false;
            }
          })
          .catch((error) => {
            if (error.message === "Network Error") {
              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
            }
          });
      }
    },

    product_lazy_loading() {
      
    this.showPaginationloader=true

      this.$root.page_loader = true;
      console.log("product_lazy_loading");
      this.filter_error_msg = "";

      if (
        this.$root.isStore == false
      ) {

        // this.product_loader = true;
        this.$root.error_message = "";
        this.$root.success_message = "";
        this.Product_MoreLoad = false;
         this.$router.push({
          query: { ...this.$route.query, page: this.page },
        });
    
        axios
          .get(this.$root.api_url + `/pim/pimresponse.php`, {
            params: {
              service: this.service,
              category: this.$route.query.category,
              store: this.store,
              url_key: this.pass_url_key,
              page: this.page,
              count: this.count,
              sort_by: this.pass_sort,
              sort_dir: this.sort_dir,
              filter: this.apifilter,
              latitude: this.$root.location.lat,
              longitude: this.$root.location.long,
              subcat_ids: this.storeFliterId,
              sq: this.$route.query.sq,
            },
          })

          .then((response) => {
       
            // this.product_loader = false;
            if (response.data.response.success === 1) {
              this.showPaginationloader=false
              if (response.data.result.products.length === 0) {
                this.filter_error_msg =
                  "No product found, please try by removing last applied filter.";
              }
              this.$root.page_loader = false;
              this.meta_title = response.data.result.meta_title;
              this.meta_description = response.data.result.meta_description;
              this.meta_keyword = response.data.result.meta_keyword;
			        window.scrollTo(0, 0);
              this.Product_list =  response.data.result.products
			  
              this.gtm_product_impressions = [];
              for (let i = 0; i < response.data.result.products.length; i++) {
                let name = response.data.result.products[i].name;
                let id = response.data.result.products[i].sku;
                let price = response.data.result.products[i].selling_price;
                let category = response.data.result.products[i].category;
                let list = response.data.result.name;
                let position = i + 1;
                this.gtm_product_impressions.push({
                  name,
                  id,
                  price,
                  category,
                  list,
                  position,
                });
              }
              // this.$gtm.trackEvent({
              //     event: 'impressionSent',
              //     category: 'Listing',
              //     action: 'Product Impression',
              //     label: 'Product List page',
              //     listing: {
              //         currencyCode: 'INR',
              //         product: this.gtm_product_impressions
              //     }
              // });
              //this.filters = response.data.result.filters;
              this.mobilefilterActive =
                response.data.result.filters[0].filter_lable;
              this.categorie_name = response.data.result.name;
              this.Product_count = response.data.result.count;
              this.pageSize = response.data.result.count / this.count;
              this.get_product_length = response.data.result.products.length;
              this.pageload = false;
			
              if (this.get_product_length >= this.count) {
                // this.page++;
                this.Product_MoreLoad = true;
              } else {
                // this.product_loader = false;
              }
            } else {
              this.$root.error_message = response.data.response.error_message;
              // this.product_loader = false;
              this.blankpage = true;
              this.pageload = false;
            }
          })
          .catch((error) => {
            if (error.message === "Network Error") {
              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
              // this.product_loader = false;
               this.$root.page_loader = false;
            }
          });
      }
    },
    sortonChange(event) {
 
      // console.log("event==", event);
      this.filter_error_msg = "";
      this.Product_MoreLoad = true;
      this.product_loader = true;
      this.Product_list = [];
      this.page = 1;
      if (event.target.value === "price_low" || event === "price_low") {
        this.pass_sort = "selling_price";
        this.$router.push({
          query: { ...this.$route.query, sort: "selling_price" },
        });
        this.$router.push({ query: { ...this.$route.query, dir: "asc" } });
        this.sort_dir = "asc";
      } else {
        this.pass_sort = event.target.value || event;
        this.$router.push({
          query: { ...this.$route.query, sort: this.select_sort },
        });
        this.$router.push({ query: { ...this.$route.query, dir: "desc" } });
        this.sort_dir = "desc";
      }
      this.$root.error_message = "";
      this.$root.success_message = "";
      axios
        .get(this.$root.api_url + `/pim/pimresponse.php`, {
          params: {
            service: this.service,
            category: this.$route.query.category,
            store: this.store,
            url_key: this.pass_url_key,
            page: this.page,
            count: this.count,
            sort_by: this.pass_sort,
            sort_dir: this.sort_dir,
            filter: this.apifilter,
            latitude: this.$root.location.lat,
            longitude: this.$root.location.long,
            sq: this.$route.query.sq,
          },
        })

        .then((response) => {
          if (response.data.response.success === 1) {
            if (response.data.result.products.length === 0) {
              this.filter_error_msg = "Products Not Found";
            }
            this.Product_list = [];
            this.Product_list = this.Product_list.concat(
              response.data.result.products
            );
            this.gtm_product_impressions = [];
            for (let i = 0; i < response.data.result.products.length; i++) {
              let name = response.data.result.products[i].name;
              let id = response.data.result.products[i].sku;
              let price = response.data.result.products[i].selling_price;
              let category = response.data.result.products[i].category;
              let list = response.data.result.name;
              let position = i + 1;
              this.gtm_product_impressions.push({
                name,
                id,
                price,
                category,
                list,
                position,
              });
            }
            // this.$gtm.trackEvent({
            //     event: 'impressionSent',
            //     category: 'Listing',
            //     action: 'Product Impression',
            //     label: 'Product List page',
            //     listing: {
            //         currencyCode: 'INR',
            //         product: this.gtm_product_impressions
            //     }
            // });
            this.categorie_name = response.data.result.name;
            this.Product_count = response.data.result.count;
            this.pageSize = response.data.result.count / this.count;
            this.get_product_length = response.data.result.products.length;
            if (this.get_product_length >= this.count) {
              // this.page++;
              this.Product_MoreLoad = true;
            } else {
              this.product_loader = false;
            }
          } else {
            this.$root.error_message = response.data.response.error_message;
            this.product_loader = false;
          }
        })
        .catch((error) => {
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
        });
    },
    sortonChangeDesktop(event) {
        this.$root.page_loader = true;
      this.select_sort_value = event.label;
      // console.log("event==", event);
      this.filter_error_msg = "";
      this.Product_MoreLoad = true;
      // this.product_loader = true;
      // this.Product_list = [];
      this.page = 1;
      if (event.code === "price_low") {
        this.pass_sort = "selling_price";
        this.$router.push({
          query: { ...this.$route.query, sort: "selling_price" },
        });
        this.$router.push({ query: { ...this.$route.query, dir: "asc" } });
        this.sort_dir = "asc";
      } else {
        this.pass_sort = event.code;
        this.$router.push({
          query: { ...this.$route.query, sort: this.select_sort },
        });
        this.$router.push({ query: { ...this.$route.query, dir: "desc" } });
        this.sort_dir = "desc";
      }
      this.$root.error_message = "";
      this.$root.success_message = "";
      axios
        .get(this.$root.api_url + `/pim/pimresponse.php`, {
          params: {
            service: this.service,
            category: this.$route.query.category,
            store: this.store,
            url_key: this.pass_url_key,
            page: this.page,
            count: this.count,
            sort_by: this.pass_sort,
            sort_dir: this.sort_dir,
            filter: this.apifilter,
            latitude: this.$root.location.lat,
            longitude: this.$root.location.long,
            sq: this.$route.query.sq,
          },
        })

        .then((response) => {
          if (response.data.response.success === 1) {
            if (response.data.result.products.length === 0) {
              this.filter_error_msg = "Products Not Found";
            }
            this.product_loader = false;
            this.$root.page_loader = false;
            this.Product_list= response.data.result.products;
            // this.Product_list = [];
            // this.Product_list = this.Product_list.concat(
            //   response.data.result.products
            // );
            this.gtm_product_impressions = [];
            for (let i = 0; i < response.data.result.products.length; i++) {
              let name = response.data.result.products[i].name;
              let id = response.data.result.products[i].sku;
              let price = response.data.result.products[i].selling_price;
              let category = response.data.result.products[i].category;
              let list = response.data.result.name;
              let position = i + 1;
              this.gtm_product_impressions.push({
                name,
                id,
                price,
                category,
                list,
                position,
              });
            }
            // this.$gtm.trackEvent({
            //     event: 'impressionSent',
            //     category: 'Listing',
            //     action: 'Product Impression',
            //     label: 'Product List page',
            //     listing: {
            //         currencyCode: 'INR',
            //         product: this.gtm_product_impressions
            //     }
            // });
            this.categorie_name = response.data.result.name;
            this.Product_count = response.data.result.count;
            this.pageSize = response.data.result.count / this.count;
            this.get_product_length = response.data.result.products.length;
            if (this.get_product_length >= this.count) {
              // this.page++;
              this.Product_MoreLoad = true;
            } else {
              this.product_loader = false;
            }
          } else {
            this.$root.error_message = response.data.response.error_message;
            this.product_loader = false;
          }
        })
        .catch((error) => {
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
          this.$root.page_loader = false;
        });
    },
    removefilter: function (index) {
      this.showPagination=false;
      console.log("remove filter")
      this.filter_error_msg = "";
      // console.log(index, this.filtersAppied[index], this.filterview[index]);
      this.filtersAppied.splice(index, 1);
      this.filterview.splice(index, 1);
      this.apifilter = "";
      for (var i = 0; i < this.filtersAppied.length; i++) {
        this.apifilter += this.filtersAppied[i].replace(/\s+/g, "+");
        if (i < this.filtersAppied.length - 1) {
          this.apifilter += ",";
        }
      }
      this.$router.push({
        query: { ...this.$route.query, filter: this.filtersAppied.toString() },
      });
      window.scrollTo(0, 0);
      this.Product_MoreLoad = true;
      this.product_loader = true;
      this.Product_list = [];
      this.page = 1;
      this.$root.error_message = "";
      this.$root.success_message = "";
      axios
        .get(this.$root.api_url + `/pim/pimresponse.php`, {
          params: {
            service: this.service,
            category: this.$route.query.category,
            store: this.store,
            url_key: this.pass_url_key,
            page: this.page,
            count: this.count,
            sort_by: this.pass_sort,
            sort_dir: this.sort_dir,
            filter: this.apifilter,
            latitude: this.$root.location.lat,
            longitude: this.$root.location.long,
            sq: this.$route.query.sq,
          },
        })

        .then((response) => {
          if (response.data.response.success === 1) {
            this.product_loader = false;
            if(response.data.result.count>20){
                this.showPagination=true;
                this.pageCount = Math.ceil(response.data.result.count/20);
              }
            if (response.data.result.products.length === 0) {
              
              this.filter_error_msg =
                "No product found, please try by removing last applied filter.";
            }
            // this.Product_list = [];
            // this.Product_list = this.Product_list.concat(
            //   response.data.result.products
            // );
            this.Product_list=response.data.result.products;
            this.gtm_product_impressions = [];
            for (let i = 0; i < response.data.result.products.length; i++) {
              let name = response.data.result.products[i].name;
              let id = response.data.result.products[i].sku;
              let price = response.data.result.products[i].selling_price;
              let category = response.data.result.products[i].category;
              let list = response.data.result.name;
              let position = i + 1;
              this.gtm_product_impressions.push({
                name,
                id,
                price,
                category,
                list,
                position,
              });
            }
            // this.$gtm.trackEvent({
            //     event: 'impressionSent',
            //     category: 'Listing',
            //     action: 'Product Impression',
            //     label: 'Product List page',
            //     listing: {
            //         currencyCode: 'INR',
            //         product: this.gtm_product_impressions
            //     }
            // });
            this.filters = response.data.result.filters;
            this.categorie_name = response.data.result.name;
            this.Product_count = response.data.result.count;
            this.pageSize = response.data.result.count / this.count;
            this.get_product_length = response.data.result.products.length;
            if (this.get_product_length >= this.count) {
              // this.page++;
              this.Product_MoreLoad = true;
            } else {
              this.product_loader = false;
            }
          } else {
            this.showPagination=false;
            this.$root.error_message = response.data.response.error_message;
            this.product_loader = false;
          }
        })
        .catch((error) => {
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
        });
    },
    removeallfilter: function () {
      this.filter_error_msg = "";
      this.filtersAppied = [];
      this.apifilter = "";
      this.filterview = [];
      window.scrollTo(0, 0);
      this.Product_MoreLoad = true;
      this.product_loader = true;
      this.Product_list = [];
      this.page = 1;
      this.$root.error_message = "";
      this.$root.success_message = "";
      this.$router.push({ query: { ...this.$route.query, filter: "" } });
      axios
        .get(this.$root.api_url + `/pim/pimresponse.php`, {
          params: {
            service: this.service,
            category: this.$route.query.category,
            store: this.store,
            url_key: this.pass_url_key,
            page: this.page,
            count: this.count,
            sort_by: this.pass_sort,
            sort_dir: this.sort_dir,
            filter: this.apifilter,
            latitude: this.$root.location.lat,
            longitude: this.$root.location.long,
            sq: this.$route.query.sq,
          },
        })

        .then((response) => {
          if (response.data.response.success === 1) {
            if (response.data.result.products.length === 0) {
              this.filter_error_msg =
                "No product found, please try by removing last applied filter.";
            }
            this.Product_list = [];
            this.Product_list = this.Product_list.concat(
              response.data.result.products
            );
            this.gtm_product_impressions = [];
            for (let i = 0; i < response.data.result.products.length; i++) {
              let name = response.data.result.products[i].name;
              let id = response.data.result.products[i].sku;
              let price = response.data.result.products[i].selling_price;
              let category = response.data.result.products[i].category;
              let list = response.data.result.name;
              let position = i + 1;
              this.gtm_product_impressions.push({
                name,
                id,
                price,
                category,
                list,
                position,
              });
            }
            // this.$gtm.trackEvent({
            //     event: 'impressionSent',
            //     category: 'Listing',
            //     action: 'Product Impression',
            //     label: 'Product List page',
            //     listing: {
            //         currencyCode: 'INR',
            //         product: this.gtm_product_impressions
            //     }
            // });
            this.filters = response.data.result.filters;
            this.categorie_name = response.data.result.name;
            this.Product_count = response.data.result.count;
            this.pageSize = response.data.result.count / this.count;
            this.get_product_length = response.data.result.products.length;
            if (this.get_product_length >= this.count) {
              // this.page++;
              this.Product_MoreLoad = true;
            } else {
              this.product_loader = false;
            }
          } else {
            this.$root.error_message = response.data.response.error_message;
            this.product_loader = false;
          }
        })
        .catch((error) => {
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
        });
    },
    formatPrice(value, precision = false) {
      let val;

      if (precision) val = (value / 1).toFixed(2).replace(",", ",");
      else val = (value / 1).toFixed(0).replace(",", ",");

      return `<span>&#8377;</span> ${val
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        .replace(".00", "<small>.00</small>")} `;
    },
    addfilter: function (label, element, value, value_key) {
      this.showPagination=false;
      console.log("add filter function")
      this.filter_error_msg = "";
      if (this.filtersAppied.indexOf(element + "-" + value) > -1) {
        for (let i = 0; i < this.filtersAppied.length; i++) {
          if (this.filtersAppied[i] === element + "-" + value) {
            this.filtersAppied.splice(i, 1);
            this.filterview.splice(i, 1);
          }
        }
      } else {
        this.filtersAppied.push(element + "-" + value);
        this.filterview.push(label + ": " + value);
      }
      this.apifilter = this.filtersAppied.join(",");
      // this.apifilter = "";
      // for (var i = 0; i < this.filtersAppied.length; i++) {
      // 	this.apifilter += this.filtersAppied[i].replace(/\s+/g, "+");
      // 	if (i < this.filtersAppied.length - 1) {
      // 		this.apifilter += ",";
      // 	}
      // }
      this.$router.push({
        query: { ...this.$route.query, filter: this.filtersAppied.toString() },
      });
      window.scrollTo(0, 0);
      this.Product_MoreLoad = true;
      this.product_loader = true;
      this.Product_list = [];
      this.page = 1;
      this.$root.error_message = "";
      this.$root.success_message = "";
     
      axios
        .get(this.$root.api_url + `/pim/pimresponse.php`, {
          params: {
            service: this.service,
            category: this.$route.query.category,
            store: this.store,
            url_key: this.pass_url_key,
            page: this.page,
            count: this.count,
            sort_by: this.pass_sort,
            sort_dir: this.sort_dir,
            filter: this.apifilter,
            latitude: this.$root.location.lat,
            longitude: this.$root.location.long,
            sq: this.$route.query.sq,
          },
        })
        .then((response) => {
          if (response.data.response.success === 1) {
            this.product_loader = false;
            if(response.data.result.count>20){
              this.showPagination=true;
              this.pageCount = Math.ceil(response.data.result.count/20);
            }
            if (response.data.result.products.length === 0) {
              this.filter_error_msg =
                "No product found, please try by removing last applied filter.";
            }
            // this.Product_list = [];
            this.filters = response.data.result.filters;
            // this.Product_list = this.Product_list.concat(
            //   response.data.result.products
            // );
            this.Product_list=response.data.result.products;
            this.gtm_product_impressions = [];
            for (let i = 0; i < response.data.result.products.length; i++) {
              let name = response.data.result.products[i].name;
              let id = response.data.result.products[i].sku;
              let price = response.data.result.products[i].selling_price;
              let category = response.data.result.products[i].category;
              let list = response.data.result.name;
              let position = i + 1;
              this.gtm_product_impressions.push({
                name,
                id,
                price,
                category,
                list,
                position,
              });
            }
            // this.$gtm.trackEvent({
            //     event: 'impressionSent',
            //     category: 'Listing',
            //     action: 'Product Impression',
            //     label: 'Product List page',
            //     listing: {
            //         currencyCode: 'INR',
            //         product: this.gtm_product_impressions
            //     }
            // });
            this.categorie_name = response.data.result.name;
            this.Product_count = response.data.result.count;
            this.pageSize = response.data.result.count / this.count;
            this.get_product_length = response.data.result.products.length;
            if (this.get_product_length >= this.count) {
              // this.page++;
              this.Product_MoreLoad = true;
            } else {
              this.product_loader = false;
            }
          } else {
            this.showPagination=false;
            this.$root.error_message = response.data.response.error_message;
            this.product_loader = false;
          }
        })
        .catch((error) => {
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
        });
    },
    isActive: function (menuItem) {
      return this.filtersAppied.indexOf(menuItem) > -1;
    },
    loadMore() {
      if (this.$route.isFromStore) {
        this.product_lazy_loading_store();
      } else {
        this.product_lazy_loading();
      }
    },
    sidebarfixed() {
      let scrollPos = 0;
      let top_set_offset = 0;
      if (window.innerWidth > 767) {
        let offsetHeight =
          document.getElementById("sidebar-inner").offsetHeight;
        let window_height = window.innerHeight;
        let mainoffsetHeight =
          document.getElementById("sidebar-main").offsetHeight;
        let offsetTop = document.getElementById("sidebar-inner").offsetTop;
        let pageoffsetTop = window.pageYOffset;
        let topscroll = document.documentElement.scrollTop;
        if (document.body.getBoundingClientRect().top > scrollPos) {
          if (window_height - 75 < offsetHeight) {
            if (top_set_offset + 135 < topscroll) {
              document
                .getElementById("sidebar-inner")
                .classList.remove("bottom");
              document.getElementById("sidebar-inner").classList.remove("top");
              document.getElementById("sidebar-inner").style.position =
                "relative";
              document.getElementById("sidebar-inner").style.top =
                offsetTop + "px";
            } else {
              document.getElementById("sidebar-inner").classList.add("top");
              document
                .getElementById("sidebar-inner")
                .classList.remove("bottom");
              document.getElementById("sidebar-inner").style.position =
                "sticky";
              document.getElementById("sidebar-inner").style.top = "115px";
            }
          }
        } else {
          if (window_height - 115 < offsetHeight) {
            top_set_offset = document.getElementById("sidebar-inner").offsetTop;
            if (topscroll < offsetHeight + offsetTop + 115) {
              document.getElementById("sidebar-inner").classList.add("bottom");
              document.getElementById("sidebar-inner").classList.remove("top");
              document.getElementById("sidebar-inner").style.position =
                "sticky";
              document.getElementById("sidebar-inner").style.top = "auto";
              document.getElementById("sidebar-inner").style.bottom = "10px";
            }
          } else {
            document.getElementById("sidebar-inner").classList.add("top");
            document.getElementById("sidebar-inner").classList.remove("bottom");
            document.getElementById("sidebar-inner").style.position = "sticky";
            document.getElementById("sidebar-inner").style.top = "115px";
          }
        }
        scrollPos = document.body.getBoundingClientRect().top;
      }
    },
  },
  mounted() {
    (this.$root.menuActive = true),
      (this.$root.error_message = ""),
      (this.$root.success_message = ""),
      (this.$root.page_loader = false);
    if (this.$route.query.isFromStore) {
      this.$root.isStore = false;
      this.store = this.$route.query.store;
      this.service = "storeProducts";
      this.getProductListStore();
    } else {
      this.service = "category_products";
      this.store = this.$root.store;
      // if(this.$root.isStore == true) {
      this.getAllStores();
      this.getProductList();
      // } else{
      //   this.getProductList()

      // }
    }

    $cookies.set(
      window.location.hostname.substring(10, 4) + "_last_list_path",
      this.$route.fullPath
    );
    $(".filterClose").click(function () {
      // alert('asdjldsjkoasdd');
      $(".rightFilterWrap").removeClass("showFilter");
    });
  },
  created() {
    this.$on("changeIsActive", (value) => {
      this.isSeeOtherActive = value;
    });

    if (screen.width < 767) {
      this.isMobile = true;
    }

    if (screen.width <= 767) {
      this.filter_status = false;
    }
    if (this.$route.query.filter) {
      this.filtersAppied = this.$route.query.filter.split(",");
      this.filterview = this.$route.query.filter.replace(/-/g, ": ").split(",");
      this.apifilter = "";
      for (var i = 0; i < this.filtersAppied.length; i++) {
        this.apifilter += this.filtersAppied[i].replace(/\s+/g, "+");
        if (i < this.filtersAppied.length - 1) {
          this.apifilter += ",";
        }
      }
    }
    if (this.$route.query.sort) {
      if (
        this.$route.query.sort === "selling_price" &&
        this.$route.query.dir == "asc"
      ) {
        this.select_sort = "price_low";
        this.pass_sort = "selling_price";
        this.sort_dir = "asc";
      } else {
        this.select_sort = this.$route.query.sort;
        this.pass_sort = this.$route.query.sort;
        this.sort_dir = "desc";
      }
    }
    //window.scrollTo(0, 0);

    this.enterCreated = true;

    // window.addEventListener('scroll', this.product_lazy_loading);
    let scrollPos = 0;
    let top_set_offset = 0;
    window.addEventListener("scroll", function sidebarfixed() {
      if (window.innerWidth > 767) {
        let offsetHeight =
          document.getElementById("sidebar-inner").offsetHeight;
        let window_height = window.innerHeight;
        let mainoffsetHeight =
          document.getElementById("sidebar-main").offsetHeight;
        let offsetTop = document.getElementById("sidebar-inner").offsetTop;
        let pageoffsetTop = window.pageYOffset;
        let topscroll = document.documentElement.scrollTop;
        if (document.body.getBoundingClientRect().top > scrollPos) {
          if (window_height - 115 < offsetHeight) {
            if (top_set_offset + 135 < topscroll) {
              document
                .getElementById("sidebar-inner")
                .classList.remove("bottom");
              document.getElementById("sidebar-inner").classList.remove("top");
              document.getElementById("sidebar-inner").style.position =
                "relative";
              document.getElementById("sidebar-inner").style.top =
                offsetTop + "px";
            } else {
              document.getElementById("sidebar-inner").classList.add("top");
              document
                .getElementById("sidebar-inner")
                .classList.remove("bottom");
              document.getElementById("sidebar-inner").style.position =
                "sticky";
              document.getElementById("sidebar-inner").style.top = "115px";
            }
          }
        } else {
          if (window_height - 115 < offsetHeight) {
            top_set_offset = document.getElementById("sidebar-inner").offsetTop;
            if (topscroll < offsetHeight + offsetTop + 115) {
              document.getElementById("sidebar-inner").classList.add("bottom");
              document.getElementById("sidebar-inner").classList.remove("top");
              document.getElementById("sidebar-inner").style.position =
                "sticky";
              document.getElementById("sidebar-inner").style.top = "auto";
              document.getElementById("sidebar-inner").style.bottom = "20px";
            }
          } else {
            document.getElementById("sidebar-inner").classList.add("top");
            document.getElementById("sidebar-inner").classList.remove("bottom");
            document.getElementById("sidebar-inner").style.position = "sticky";
            document.getElementById("sidebar-inner").style.top = "115px";
          }
        }
        scrollPos = document.body.getBoundingClientRect().top;
      }
    });
  },
  watch: {
			otp_number: {
				handler: function () {
				console.log(this.$router.query.page)
				},
			},

      '$route.query.sq'() {
        
        this.Product_MoreLoad=true
        this.product_loader = true
        
      this.getProductListStore(); 
      }
		},
  beforeDestroy() {
    window.removeEventListener("scroll", this.sidebarfixed());
  },

  beforeMount() {
   
    if(this.$route.query.page){
      let checkPageno=isNaN(this.$route.query.page)
      if(checkPageno || this.$route.query.page==0){
         this.page=1
          this.$router.push({
          query: { ...this.$route.query, page: this.page },
        });
      }
      else{
         this.page=this.$route.query.page
      }

    }
    this.check_similar_store();
    var curroute = this.$router.currentRoute.path;
    
    if (curroute.includes("store")) {
      this.otherstorecheck = true;
    }

    document.addEventListener("keyup", (evt) => {
      if (evt.keyCode == 27) {
        this.isStorePopUp = false;
      }
    });
  },
};
</script>
<style >
.product-list-main .sidebar-main .filter-box .list-unstyled::-webkit-scrollbar {
  background-color: #f2f2f2;
  width: 10px;
}
.paginationloader{
  top:40%;
  left:50%;
}

.product-list-main
  .sidebar-main
  .filter-box
  .list-unstyled::-webkit-scrollbar-track {
  background-color: #f2f2f2;
}
.product-list-main
  .sidebar-main
  .filter-box
  .list-unstyled::-webkit-scrollbar-track:hover {
  background-color: #f2f2f2;
}

/* scrollbar itself */
.product-list-main
  .sidebar-main
  .filter-box
  .list-unstyled::-webkit-scrollbar-thumb {
  background-color: #787878;
  border-radius: 0px;
}
.product-list-main
  .sidebar-main
  .filter-box
  .list-unstyled::-webkit-scrollbar-thumb:hover {
  background-color: #787878;
}
.storeHeader {
  height: 280px;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}

.qty_box {
  width: 110px;
}
.qty_box a.disabled {
  opacity: 0.5;
  cursor: no-drop;
}
.qty_box a {
  padding: 5px 9px;
  border: 1px solid #efefef;
  vertical-align: top;
  margin: 0;
  height: 30px;
  color: var(--font-dark-blue);
  background-color: #efefef;
  font-size: 12px;
  display: inline-block;
  border-radius: 50%;
}
.qty_box input {
  text-align: center;
  outline: none;
  font-size: 15px;
  padding: 2px;
  height: 30px;
  width: 30px;
  cursor: default;
  border: none;
  /* font-family: 'Avenir-Roman'; */
  text-transform: uppercase;
  background-color: transparent;
}
nav#sidebar-inner {
  width: 100%;
}
.listWish {
  font-size: 25px;
  position: absolute;
  top: 1px;
  right: 8px;
  color: #d4d5d9;
  display: none;
}
.listWish:hover {
  color: var(--main-color);
}
.slide-box:hover .listWish {
  display: block;
}
.sortDrop {
  border: 1px solid #ededed;
  /* padding: 10px; */
  cursor: pointer;
  position: relative;
  font-size: 14px;
}
.sortDrop > span {
  padding: 10px;
  display: inline-block;
  width: 100%;
}
.sortDrop .sortTitle {
  font-family: "lhmBold";
}
.sortDropList {
  display: none;
  padding: 0;
  position: absolute;
  z-index: 9;
  background-color: #fff;
  width: calc(100% + 2px);
  border: 1px solid #ededed;
  border-top: none;
  left: -1px;
}
.sortDrop:hover {
  border-bottom-color: #fff;
}
.sortDrop:hover .sortDropList {
  display: block;
  box-shadow: 0 8px 10px 0 rgba(0, 0, 0, 0.08);
}
.sortDropList li {
  list-style: none;
  font-size: 14px;
  color: var(--font-dark-blue);
  cursor: pointer;
  padding: 10px 20px;
}
.sortDropList li.sortActive {
  background-color: #f5f5f5;
}
.sortDropList li:hover {
  background-color: #f5f5f5;
}
.product-section-main .sort-item-count {
  border: none;
  padding: 0;
  margin: 0;
}
.gProductName {
  font-family: "lhmRegular";
  font-size: 14px;
  padding-top: 10px;
  margin: 0;
  height: 43px;
}
.gProductUnit {
  font-size: var(--font-size-regular);
  margin-bottom: 0;
  font-family: "lhmRegular";
  min-height: 24px;
}
.product-section-main .product-list .product-box {
  margin-bottom: 5px;
}
.gProductPrice {
  font-family: "lhmBold";
  margin-bottom: 0px;
  font-size: 16px !important;
}
.gProductPrice del {
  font-family: "lhm";
}
.gProductAdd button {
  background-color: #fff;
  border: 1px solid var(--main-color);
  color: var(--main-color);
  text-align: center;
  padding: 6px;
  font-family: "lhmBold";
  /* border-radius: 5px; */
  margin: 8px 0;
  width: 100%;
  position: relative;
  cursor: pointer;
}
.gProductAdd button span {
  position: absolute;
  right: 0;
  padding: 3px 10px;
  background-color: rgba(0, 0, 0, 0.1123);
  top: 0;
  font-weight: 100;
  font-size: 20px;
  display: none;
}
.filterMore {
  color: var(--main-color);
  font-size: 15px;
  font-family: "lhmSemiBold";
  /* text-align: center; */
  margin-top: 14px;
  margin-left: 0;
  cursor: pointer;
  margin-bottom: 0;
}
.product-list-main .sidebar-main .filter-box .list-unstyled a:hover:before {
  border-color: var(--main-color);
  background-color: var(--main-color);
}
.product-list-main .sidebar-main .filter-box .list-unstyled a.check:before {
  background-color: var(--main-color);
  color: #fff;
  content: url(/img/Vector.png);
  border-color: var(--main-color);
}
.product-list-main .mobile-filter {
  background-color: #fff;
  color: #626262 !important;
  box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.1);
}
.tabWrap span {
  cursor: pointer;
  font-family: "lhmSemiBold";
  margin: 0 15px;
  padding: 8px;
  display: inline-block;
  text-transform: uppercase;
}
.tabWrap p {
  margin-bottom: 0;
  /* border-bottom: 1px solid #ededed; */
  color: var(--font-dark-blue);
}
.tabWrap span.listTabActive {
  color: var(--main-color);
  border-bottom: 2px solid var(--main-color);
  margin-bottom: 0 !important;
}
.cardGrid {
  margin-top: 0px;
  background-color: #000;
  padding-top: 30px;
  padding-bottom: 30px;
}
.listOtherOptions {
  position: absolute;
  bottom: 50px;
  right: 10px;
  background-color: #f1f2f1;
  border: 1px solid #d4d5d9;
  color: #626262;
  width: 30px;
  text-align: center;
  height: 30px;
  /* line-height: 30px; */
  border-radius: 50px;
  cursor: pointer;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
  transition: width 0.2s ease-in-out;
  padding-right: 12px !important;
  display: inline-block !important;
  padding-left: 12px;
}
.listOtherOptions i {
  line-height: 28px;
}
.listOtherOptions span {
  line-height: 28px;
}
.listOtherOptions span {
  display: none;
  font-size: 14px;
  padding: 0 9px;
  vertical-align: bottom;
  transition: display 0.2s ease-in-out;
}
.listOtherOptions:hover span {
  display: inline-block;
}
.listOtherOptions:hover {
  width: auto;
  display: inline-block;
  padding-right: 20px !important;
}
.product-box:hover .listOtherOptions {
  opacity: 1;
  display: flex !important;
}

.SkeletonFilter1 {
  height: 100vh;
  display: block;
  /* margin-top:10px ; */
}
.productSkeleton .Skeletonitem {
  height: 315px;
}
.SkeletonitemPLPHeader {
  height:60px;
  display:block;
  margin-bottom: 5px;
}
@media screen and (max-width: 767px) {

  .compareRight {
    text-align: center;
  }
  .compareRight .col-md-4.text-left {
    text-align: center !important;
  }
  .compareRight .col-md-4 {
    padding: 5px 0 !important;
  }
  .sortDrop {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 50% !important;
    z-index: 998;
    line-height: 20px;
    box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.1);
  }
  .sortDropList {
    bottom: 43px;
    width: 100vw;
    box-shadow: none !important;
  }
  .sortTitle {
    display: none;
  }
  .sortDrop i {
    display: none;
  }
  .listOtherOptions i {
    line-height: 22px;
  }
  .listOtherOptions span {
    line-height: 22px;
  }
  .listOtherOptions {
    padding-top: 3px;
  }
  .filterMore {
    padding-left: 15px;
  }
  .gProductAdd {
    margin: 0 5px;
  }
  /* .product-sort ,.apply_mobile_filter {
									    background: red;
									} */
  .close_mobile_filter {
    border: 1px solid #fff;
    color: #626262;
    box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.1);
  }
  .product-list-main .sidebar-main .filter-box .list-unstyled {
    max-height: none !important;
    overflow: none !important;
  }
  .dropdown-toggle::after {
    display: none !important;
    width: 0;
    height: 0;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }

  
  .SkeletonFilter1 {
    display: none;
  }
  .productSkeleton .Skeletonitem {
    height: 250px;
}
.SkeletonitemPLPHeader {
  height:90px;
}
}


</style>